import jsPDF from 'jspdf';
import ip from '../../GlobelIP';
import { Message, toaster } from 'rsuite';
const convertDimension = (value, fromUnit, toUnit) => {
  if (!value || isNaN(value)) return value;

  const num = parseFloat(value);

  if (fromUnit === toUnit) return num;

  // cm → inch
  if (fromUnit === 'cm' && toUnit === 'inch') {
    return +(num / 2.54).toFixed(2);
  }

  // inch → cm
  if (fromUnit === 'inch' && toUnit === 'cm') {
    return +(num * 2.54).toFixed(2);
  }

  return num;
};

const convertDimensionsForPDF = (product, selectedUnit) => {
  const originalUnit = product.attributes?.SizeUnit?.toLowerCase().includes('inch') ? 'inch' : 'cm';

  const length = product.attributes?.Length || 0;
  const width = product.attributes?.Width || 0;
  const height = product.attributes?.Height || 0;

  const finalUnit = selectedUnit.toLowerCase();

  const convertedLength = convertDimension(length, originalUnit, finalUnit);
  const convertedWidth = convertDimension(width, originalUnit, finalUnit);
  const convertedHeight = convertDimension(height, originalUnit, finalUnit);

  return `${convertedLength} x ${convertedWidth} x ${convertedHeight} ${finalUnit}`;
};

const generatePDF1 = async (
  cata,
  selectedRowIds,
  printOrNot,
  label,
  data2,
  unit = 'cm',
  currency = 'USD',
  selectedRate
) => {
  // console.log('printOrNot222', printOrNot);
  const doc = new jsPDF('portrait');
  const logoUrl = data2.length > 0 ? data2[0].attributes?.Logo?.data?.attributes?.url : '';

  // Define table properties
  const startX = 10;
  const startY = 20;
  const cellWidth = 100;
  const cellHeight = 10; // Decreased table cell height
  const fontSize = 10; // Decreased font size
  const tableLineWidth = 0.1;

  const attributeDisplayNames = {
    aliascd: `${label[0].attributes.AliasCode}`,
    description: `${label[0].attributes.Description}`,
    productName: `${label[0].attributes.ProductName}`,
    prodtypecd: `${label[0].attributes.ProductType}`,
    dimension: `Dimension`,
    finish: `${label[0]?.attributes.finish}/${label[0]?.attributes.color}`,
    saleprice: `${label[0].attributes.SalePrice}`,
    netwgt: `${label[0].attributes.NetWgt}`
  };

  // Function to add a new page when necessary
  const addNewPageIfNecessary = currentY => {
    if (currentY + cellHeight > doc.internal.pageSize.getHeight() - 10) {
      doc.addPage();
      return 10; // Start from the top of the new page
    }
    return currentY;
  };

  // Function to display product data with scaled image
  const displayProduct = (product, currentX, currentY, catadata) => {
    return new Promise(resolve => {
      const value = product;
      const imageX = currentX + 4;
      const imageY = currentY;

      // Container size for the image
      const imageWidth = cellWidth - 6;
      const imageHeight = 80; // Default height for the image
      doc.setDrawColor(0); // Set border color
      doc.setLineWidth(0.4);
      doc.rect(imageX, imageY, imageWidth, imageHeight, 'S');

      if (value && value.attributes?.CoverImage?.data?.attributes?.url) {
        const imageSrc = `${ip}${value.attributes.CoverImage.data.attributes.url}`;

        const img = new Image();
        img.src = imageSrc;

        img.onload = () => {
          const imgWidth = img.width;
          const imgHeight = img.height;

          const aspectRatio = imgWidth / imgHeight;

          let newWidth, newHeight;
          if (imgWidth > imgHeight) {
            newWidth = imageWidth - 3;
            newHeight = newWidth / aspectRatio;
          } else {
            newHeight = imageHeight - 3;
            newWidth = newHeight * aspectRatio;
          }
          const offsetX = (imageWidth - newWidth) / 2;
          const offsetY = (imageHeight - newHeight) / 2;

          doc.addImage(imageSrc, 'JPEG', imageX + offsetX, imageY + offsetY, newWidth, newHeight);
          resolve(currentY + 10); // Return the updated Y position
        };

        img.onerror = err => {
          console.error('Image failed to load:', err);
          resolve(currentY + imageHeight); // Continue with default height if image fails
        };
      } else {
        resolve(currentY + imageHeight + 10); // If no image, just move the Y position
      }
      currentX += 100; // Adjust horizontal position
      doc.setFontSize(fontSize); // Set the font size

      Object.keys(attributeDisplayNames).forEach(key => {
        const attributeLabel = attributeDisplayNames[key];
        const attributeValue = catadata[key] || '';
        // Draw border for each cell
        doc.setLineWidth(tableLineWidth);
        doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');

        // Draw lines between attribute and value
        const lineX = currentX + cellWidth / 3.1;
        const lineY1 = currentY;
        const lineY2 = currentY + cellHeight;
        doc.line(lineX, lineY1, lineX, lineY2);

        // Display attribute label and value
        doc.text(attributeLabel, currentX + 2, currentY + 7);

        if (key === 'aliascd') {
          const aliascdValue = product.attributes?.ProductId || '0';
          const aliascdString = `${aliascdValue}`;

          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(aliascdString, currentX + 34, currentY + 7);
        } else if (key === 'description') {
          const descriptionValue = product.attributes?.Description || '0';
          const descriptionString = `${descriptionValue}`;

          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(descriptionString, currentX + 34, currentY + 7);
        } else if (key === 'productName') {
          const productNametValue = product.attributes?.ProductName || '0';
          const productNameString = `${productNametValue}`;

          const maxWidth = 30; // Maximum width for the text
          const textWidth = doc.getTextWidth(productNameString);
          let displayText = productNameString;
          if (textWidth > maxWidth) {
            displayText = productNameString.substring(0, 21) + '...'; // Truncate with '...'
          }

          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(displayText, currentX + 34, currentY + 7);
        } else if (key === 'prodtypecd') {
          const prodtypecdValue = product.attributes?.ProductTypeName || '0';
          const prodtypecdString = `${prodtypecdValue}`;

          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(prodtypecdString, currentX + 34, currentY + 7);
        } else if (key === 'dimension') {
          const dimensionString = convertDimensionsForPDF(product, unit);

          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(dimensionString, currentX + 34, currentY + 7);
        } else if (key === 'finish') {
          const finishValue = product.attributes?.FinishName || 'N/A';
          const colorValue = product.attributes?.ColorName || 'N/A';
          const finishColorString = `${finishValue} / ${colorValue}`;

          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(finishColorString, currentX + 34, currentY + 7);
        } else if (key === 'saleprice') {
          let price = parseFloat(product.attributes?.SellingPrice) || 0;

          // Convert INR → selected currency
          if (currency !== 'INR') {
            price = price / selectedRate; // ⚠️ make sure selectedRate exists
          }

          // Round to 2 decimals
          price = Number(price.toFixed(2));

          const salepriceString = `${price} ${currency}`;

          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(salepriceString, currentX + 34, currentY + 7);
        } else if (key === 'netwgt') {
          const netwgtValue = product.attributes?.NetWeight || '0';
          const netwgtString = `${netwgtValue}`;

          doc.setLineWidth(tableLineWidth);
          doc.rect(currentX, currentY, cellWidth - 10, cellHeight, 'S');
          doc.text(netwgtString, currentX + 34, currentY + 7);
        } else {
          doc.text(attributeValue.toString(), currentX + cellWidth / 3, currentY + 7);
        }

        currentY += cellHeight; // Adjust vertical position
      });
      // Add a gap between products
      return currentY + imageHeight;
    });
  };

  let currentX = startX;
  let currentY = startY;
  const reversedCata = [...cata].reverse();
  const selectedProducts = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    });
  if (selectedRowIds.length === 0) {
    alert('No rows selected for export PDF1!');
    return;
  }
  // Process each product asynchronously
  for (let i = 0; i < selectedProducts.length; i++) {
    currentY = addNewPageIfNecessary(currentY);
    currentY = await displayProduct(selectedProducts[i], currentX, currentY, selectedProducts[i]);
  }
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);
  // console.log('printOrNot111', printOrNot);
  if (printOrNot === 'Print') {
    // Open the PDF in a new tab for printing
    window.open(blobUrl, '_blank');
  } else {
    // Create a download link for the PDF
    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = 'Product_List.pdf';
    downloadLink.click();
  }

  // Revoke blob URL after some time to free up memory
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
};
const handleDownloadPDF1 = async (
  cata,
  selectedRowIds,
  printOrNot,
  label,
  data2,
  setIsLoading2,
  setIsLoading3,
  selectedUnit,
  selectedCurrency,
  selectedRate
) => {
  if (printOrNot === 'Print') {
    setIsLoading3(true);
  } else {
    setIsLoading2(true);
  }
  try {
    const doc = await generatePDF1(
      cata,
      selectedRowIds,
      printOrNot,
      label,
      data2,
      selectedUnit,
      selectedCurrency,
      selectedRate
    ); // Pass selectedRowIds
    // console.log('printOrNotttt', printOrNot);
    if (printOrNot === 'Print') {
      // setIsLoading3(true);
      doc.output('dataurlnewwindow');
      setIsLoading3(false);
    } else {
      // setIsLoading2(true);
      doc.save('PDF.pdf');
      setIsLoading2(false);
    }
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

const generatePDF2 = async (
  data,
  selectedRowIds,
  selectedAttributes,
  label,
  data2,
  unit = 'cm',
  currency = 'USD',
  selectedRate
) => {
  if (selectedRowIds.length === 0) {
    alert('No rows selected for export PDF!');
    return;
  }

  const doc = new jsPDF('landscape');

  // Define table properties
  const startX = 10;
  const startY = 20; // Adjusted to reduce excessive top margin
  const cellHeight = 20;
  const headerCellHeight = 10;
  const tableLineWidth = 0.1;
  const headerCellBackgroundColor = '#D3D3D3';
  const boxWidth = 275; // Box width to match table width
  const logoWidth = 40; // Width of the logo
  const logoHeight = 10; // Height of the logo
  const fixedColumnWidths = {
    ProductId: 17, // Fixed width for ProductId
    CoverImage: 30 // Fixed width for CoverImage
  };

  // Calculate remaining width for dynamic columns
  const totalFixedWidth = fixedColumnWidths['ProductId'] + fixedColumnWidths['CoverImage'];
  const remainingWidth = boxWidth - totalFixedWidth;
  const dynamicColumnCount = selectedAttributes.length;

  // If there are selected dynamic columns, calculate width for each of them
  const dynamicColumnWidth = dynamicColumnCount > 0 ? remainingWidth / dynamicColumnCount : 0;

  // Extract company info from data2 (if available)
  const cmpnam = data2?.map(item => item.attributes.cmpnm)?.[0] || 'Company Name';
  const address = data2?.map(item => item.attributes.address)?.[0] || 'Address';
  const logoUrl = data2?.length > 0 ? data2[0]?.attributes?.Logo?.data?.attributes?.url : '';
  const img = `${ip}${logoUrl}`;

  // Add Company Name Box with Logo and Address
  const boxX = startX;
  const boxY = startY + 3;

  // Add company name box with logo, name, and address
  doc.setLineWidth(tableLineWidth);
  doc.rect(boxX, boxY, boxWidth, cellHeight);

  // Position the logo on the left side of the box
  if (img) {
    const logoX = boxX + 5;
    const logoY = boxY + 3;
    doc.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);
  }

  // Position the company name and address
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  const cmpnamTextWidth = doc.getStringUnitWidth(cmpnam) * doc.internal.scaleFactor;
  const cmpnamTextX = boxX + logoWidth + (boxWidth - logoWidth - cmpnamTextWidth) / 2;
  doc.text(cmpnam, cmpnamTextX, boxY + cellHeight / 3);

  doc.setFontSize(8);
  const addressTextWidth = doc.getStringUnitWidth(address) * doc.internal.scaleFactor;
  const addressTextX = boxX + logoWidth + (boxWidth - logoWidth - addressTextWidth) / 2;
  doc.text(address, addressTextX, boxY + cellHeight / 1.5);
  const reversedCata = [...data].reverse();
  // Filter the data based on selectedRowIds
  const selectedProducts = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    });
  if (selectedProducts.length === 0) {
    console.error('No products matched the selectedRowIds.');
    return;
  }

  // Helper function to handle page breaks if content overflows
  const addNewPageIfNecessary = currentY => {
    const pageHeight = doc.internal.pageSize.height;
    if (currentY + cellHeight > pageHeight - 10) {
      doc.addPage();
      return 10; // Reset to the top of the new page
    }
    return currentY;
  };

  // Define the column label mapping
  const labelMapping = {
    ProductId: `${label[0].attributes.AliasCode}`,
    CoverImage: 'Image',
    Description: `${label[0].attributes.Description}`,
    ProductName: `${label[0].attributes.ProductName}`,
    CategoryName: `${label[0].attributes.Category}`,
    SizeUnit: `${label[0].attributes.Sizeunit}`,
    FinishName: `${label[0].attributes.finish}`,
    ColorName: `${label[0].attributes.color}`,
    SellingPrice: `${label[0].attributes.SalePrice}`,
    BuyerSku: `${label[0].attributes.BuyerSku}`,
    BuyerName: `${label[0].attributes.BuyerName}`,
    HSNCode: `${label[0].attributes.HSN}`,
    GrossWeight: `${label[0].attributes.GrossWgt}`,
    NetWeight: `${label[0].attributes.NetWgt}`,
    ProductTypeName: `${label[0].attributes.ProductType}`,
    MOQ: `${label[0].attributes.MOQ}`,
    CBM: `${label[0].attributes.cbm}`,
    ProductCost: 'ProductCost'
  };

  // Draw Table Header (ProductId + CoverImage + selected attributes)
  let currentX = startX;
  let currentY = boxY + cellHeight;
  let allAttributes = [
    'ProductId',
    'CoverImage',
    ...selectedAttributes.filter(attribute => attribute !== 'ProductId')
  ];

  allAttributes.forEach(attribute => {
    const label = labelMapping[attribute] || attribute; // Use the label mapping for column headers
    let columnWidth;

    // Determine the column width based on whether it's a fixed column or dynamic
    if (attribute === 'ProductId' || attribute === 'CoverImage') {
      columnWidth = fixedColumnWidths[attribute]; // Fixed width for ProductId and CoverImage
    } else {
      columnWidth = dynamicColumnWidth; // Dynamic width for other columns
    }

    doc.setFillColor(headerCellBackgroundColor);
    doc.rect(currentX, currentY, columnWidth, headerCellHeight, 'F');
    doc.setTextColor(0, 0, 0);
    doc.setLineWidth(tableLineWidth);
    doc.rect(currentX, currentY, columnWidth, headerCellHeight, 'S');

    const wrappedLabel = doc.splitTextToSize(label, columnWidth - 4);
    let labelY = currentY + 5;
    wrappedLabel.forEach((line, index) => {
      doc.text(line, currentX + 2, labelY + index * 4);
    });

    currentX += columnWidth; // Move to the next column
  });

  // Reset font style for data cells
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');

  // Add Table Rows
  currentY += headerCellHeight;

  for (let product of selectedProducts) {
    currentX = startX;

    // Check if new page is required
    currentY = addNewPageIfNecessary(currentY);

    // Render rows for each attribute in `allAttributes`
    for (let attribute of allAttributes) {
      let columnWidth;

      // Determine the column width based on whether it's a fixed column or dynamic
      if (attribute === 'ProductId' || attribute === 'CoverImage') {
        columnWidth = fixedColumnWidths[attribute]; // Fixed width for ProductId and CoverImage
      } else {
        columnWidth = dynamicColumnWidth; // Dynamic width for other columns
      }

      doc.setLineWidth(tableLineWidth);
      doc.rect(currentX, currentY, columnWidth, cellHeight, 'S');

      // Get the value for the current attribute
      // const value = product.attributes[attribute] || '-';
      let value;

      if (attribute === 'SizeUnit') {
        value = convertDimensionsForPDF(product, unit);
      } else if (attribute === 'SellingPrice') {
        let price = parseFloat(product.attributes?.SellingPrice) || 0;

        // Convert INR → selected currency
        if (currency !== 'INR' && selectedRate) {
          price = price / selectedRate;
        }

        price = Number(price.toFixed(2));

        value = `${price} ${currency}`;
      } else {
        value = product.attributes[attribute] || '-';
      }

      if (attribute === 'CoverImage') {
        const imageUrl = product.attributes.CoverImage?.data?.attributes?.url || '';
        if (imageUrl) {
          const image = new Image();
          image.src = `${ip}${imageUrl}`;

          // Create a promise to load the image and get its dimensions
          await new Promise((resolve, reject) => {
            image.onload = function () {
              const originalWidth = image.width;
              const originalHeight = image.height;

              // Scale image to fit within cell width/height while maintaining aspect ratio
              const imageWidth = 20; // 4px padding on each side
              const imageHeight = (originalHeight / originalWidth) * imageWidth;

              // If image height exceeds cell height, scale it down
              if (imageHeight > cellHeight - 4) {
                const scalingFactor = (cellHeight - 4) / imageHeight;
                doc.addImage(
                  image,
                  'JPEG',
                  currentX + 4,
                  currentY + 2,
                  imageWidth * scalingFactor,
                  imageHeight * scalingFactor
                );
              } else {
                doc.addImage(image, 'JPEG', currentX + 4, currentY + 2, imageWidth, imageHeight);
              }

              resolve();
            };

            image.onerror = function () {
              console.error('Image failed to load:', image.src); // Log for debugging
              // Optionally, you can add a placeholder image or skip the image rendering
              doc.text('No Image', currentX + 2, currentY + 7); // Placeholder if no image
              resolve(); // Resolves the promise even if image fails to load
            };
          });
        } else {
          doc.text('No Image', currentX + 2, currentY + 7); // Placeholder if no image
        }
      } else {
        const wrappedText = doc.splitTextToSize(value.toString(), columnWidth - 4);
        let textY = currentY + 5;

        wrappedText.forEach(line => {
          if (textY > currentY + cellHeight - 2) {
            doc.text('...', currentX + 2, textY - 4); // Truncate with "..."
            return;
          }
          doc.text(line, currentX + 2, textY);
          textY += 4;
        });
      }

      currentX += columnWidth;
    }

    currentY += cellHeight;
  }
  return doc;
};

const handleDownloadPDF2 = async (
  cata,
  selectedRowIds,
  selectedAttributes,
  setIsLoading2,
  setIsLoading3,
  label,
  data2,
  selectedUnit,
  selectedCurrency,
  selectedRate
) => {
  if (print) {
    setIsLoading3(true);
  } else {
    setIsLoading2(true);
  }
  try {
    const doc = await generatePDF2(
      cata,
      selectedRowIds,
      selectedAttributes,
      label,
      data2,
      selectedUnit,
      selectedCurrency,
      selectedRate
    );

    const pdfBlob = doc.output('blob');
    // console.log('print', print);
    if (print) {
      // If printOrNot is true, directly print the document
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, '_blank');
      doc.save('PDF.pdf');
      setIsLoading3(false);
    } else {
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const a = document.createElement('a');
      a.href = pdfUrl;
      a.download = 'product-details.pdf';
      a.click();
      URL.revokeObjectURL(pdfUrl);
      setIsLoading2(false);
      // setPrint(false)// Clean up the URL object after download
    }
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

const generatePDF3v1 = async (cata, selectedRowIds, attribute, label) => {
  const doc = new jsPDF('landscape');
  const reversedCata = [
    ...cata.sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    })
  ];
  // Filter the products based on selectedRowIds
  const filteredData = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .map(product => {
      const { CoverImage, ProductId, Length, Width, Height, SizeUnit, SetStatus, SetSizes } =
        product;

      // Start with the basic product data
      const mappedProduct = {
        CoverImage: ip + product.attributes.CoverImage?.data?.attributes?.url || 'No Image',
        ProductId: product.attributes.ProductId || 'No AliasCode',
        SizeUnit: product.attributes.SizeUnit || 'N/A',
        NetWeight: product.attributes.NetWeight || 'NetWt'
      };

      // If SetStatus is 'Set', check for SetSizes
      if (product.attributes?.SetStatus === 'Set') {
        if (product.attributes.SetSizes && product.attributes.SetSizes.length > 0) {
          // If SetSizes exists and is not empty, map the SetSizes dimensions and include Description and ColorName
          mappedProduct.Dimension = product.attributes.SetSizes.map(size => {
            return `${size.Description ? size.Description + ' - ' : ''}${size.Length || 0} x ${
              size.Width || 0
            } x ${size.Height || 0} ${size.SizeUnit}`;
          });
          mappedProduct.ColorInfo = product.attributes.SetSizes.map(size =>
            size.ColorName ? size.ColorName : ' '
          );
          mappedProduct.NetWt = product.attributes.SetSizes.map(size =>
            size.NetWt ? size.NetWt : ' '
          );
        } else {
          // If SetSizes is empty, fallback to the main product's dimensions with Description and ColorName
          mappedProduct.Dimension = [
            `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '} `
          ];
          mappedProduct.ColorInfo = product.attributes.ColorName
            ? [product.attributes.ColorName]
            : [' '];
          mappedProduct.NetWt = product.attributes.NetWeight
            ? [product.attributes.NetWeight]
            : [' '];
        }
      } else {
        // If SetStatus is not 'Set', directly use the product's dimensions with Description and ColorName
        const { Length, Height, Width, SizeUnit } = product.attributes;
        mappedProduct.Dimension = [
          `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '}`
        ];
        mappedProduct.ColorInfo = product.attributes.ColorName
          ? [product.attributes.ColorName]
          : [' '];
        mappedProduct.NetWt = product.attributes.NetWeight ? [product.attributes.NetWeight] : [' '];
      }

      return mappedProduct;
    });

  const imageWidth = 90 * 1.5; // Image width increased by 50%
  const imageHeight = 90 * 1.5; // Image height adjusted to 80% of the original size
  const xOffset = 70; // Left margin for the first column
  const yOffset = 30; // Top margin for the first row
  const xSpacing = 100; // Horizontal space between columns
  const ySpacing = imageHeight + 20; // Vertical space between rows
  const maxProductsPerPage = 1; // 3x3 grid
  let productCount = 0; // Track the number of products on the current page

  const lineHeight = 2; // Line height for text

  // Iterate through the filtered data and add each product to the PDF
  for (let index = 0; index < filteredData.length; index++) {
    const data = filteredData[index];

    // Add a new page if the current page is full (9 products)
    if (productCount >= maxProductsPerPage) {
      doc.addPage();
      productCount = 0;
    }

    // Calculate the row and column for the current product in the 3x3 grid
    const row = Math.floor(productCount / 3); // 3 columns per row
    const col = productCount % 3; // 3 rows per page

    const xPos = xOffset + col * xSpacing; // X position for the current column
    const yPos = yOffset + row * ySpacing; // Y position for the current row

    const detailsXPos = xPos + imageWidth + 10; // Position for product details

    // Add product image
    // if (data.CoverImage !== 'No Image') {
    //   try {
    //     const img = await fetchImageAsBase64(data.CoverImage);
    //     doc.addImage(img, 'JPEG', xPos, yPos, imageWidth, imageHeight);
    //   } catch (error) {
    //     console.log('Error fetching image', error);
    //     doc.text('Image Failed', xPos, yPos); // Fallback text if image loading fails
    //   }
    // } else {
    //   doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    // }
    if (data.CoverImage !== 'No Image') {
      try {
        // Fetch the image as base64
        const img = await fetchImageAsBase64(data.CoverImage);

        // Create an image element
        const imgElement = new Image();
        imgElement.src = img;

        // Wait for the image to load before adding it to the PDF
        await new Promise((resolve, reject) => {
          imgElement.onload = () => {
            const imgAspectRatio = imgElement.width / imgElement.height;

            // Calculate the scaled width and height to maintain the aspect ratio
            let scaledWidth = imageWidth;
            let scaledHeight = imageWidth / imgAspectRatio;

            // If the scaled height exceeds the container height, adjust to fit
            if (scaledHeight > imageHeight) {
              scaledHeight = imageHeight;
              scaledWidth = imageHeight * imgAspectRatio;
            }

            // Ensure the image doesn't exceed the container dimensions
            scaledWidth = Math.min(scaledWidth, imageWidth); // Constrain to container width
            scaledHeight = Math.min(scaledHeight, imageHeight); // Constrain to container height

            // Calculate the X and Y positions to center the image within the container
            const imageXPos = xPos + (imageWidth - scaledWidth) / 2; // Center the image horizontally
            const imageYPos = yPos + (imageHeight - scaledHeight) / 2; // Center the image vertically

            // Add the image to the PDF with the new width, height, and centered position
            doc.addImage(img, 'JPEG', imageXPos, imageYPos, scaledWidth, scaledHeight);

            resolve(); // Resolve the promise once the image is added
          };

          imgElement.onerror = reject; // Reject the promise if there's an error loading the image
        });
      } catch (error) {
        console.log('Error fetching image:', error);
        doc.text('Image Failed', xPos, yPos); // Fallback text if image loading fails
      }
    } else {
      doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    }
    // Add product details to the right of the image
    doc.setFontSize(9); // Font size for product details

    const detailsY = yPos + imageHeight + 5; // Adjusted vertical space for details

    // Format dimension string based on whether it's a single set or multiple sets
    const dimensionString = data.Dimension.join(' \n '); // Join dimensions into one string if there are multiple sets

    // Calculate the width of the text box for centering the text horizontally
    const textWidth = doc.getTextWidth(`AliasCode: ${data.ProductId}`);
    const centerX = xPos + (imageWidth - textWidth) / 2;
    if (attribute?.includes('ProductId') && label?.[0]?.attributes?.AliasCode && data?.ProductId) {
      doc.text(`${label[0].attributes.AliasCode} :   ${data.ProductId}`, centerX - 12, detailsY);
    }

    if (attribute?.includes('Size')) {
      doc.text(`Size        :`, centerX - 12, detailsY + lineHeight * 2);
    }

    // We will calculate where to position the color info
    const dimensionStartY = detailsY + lineHeight * 2; // Start a bit lower than the label
    // console.log("data is :",data)

    // Print the first dimension inline with the "Dimension:" label
    const firstDimension = data.Dimension[0];
    // const firstNetWt = data.NetWt?.[0] > 0 ? `- ${data.NetWt[0]}` : '';
    if (attribute?.includes('Size')) {
      doc.text(`${firstDimension} `, centerX + 4, dimensionStartY); // First dimension inline
    }

    // Print remaining dimensions on subsequent lines, with indentation
    let lineStartY = dimensionStartY + lineHeight * 2; // Space for the next line of dimensions
    lineStartY = attribute?.includes('Size') ? dimensionStartY + lineHeight * 2 : dimensionStartY;
    if (attribute?.includes('Size')) {
      let i = 0;
      data.Dimension.slice(1).forEach((dimension, idx) => {
        if (i < 2) {
          // const netWeight = data.NetWt?.[idx + 1] ? `- ${data.NetWt[idx + 1]}` : '';
          const lineY = lineStartY + idx * (lineHeight * 2);
          doc.text(`${dimension}`, centerX + 4, lineY);
          i++;
        }
      });
    }

    // Adjust position for the Color field
    // const colorStartY = lineStartY + (data.Dimension.length - 1) * (lineHeight * 2) + 1; // Adding 2 for a small space after dimensions
    //       let colorYStart = data.Dimension.length >= 3 && attribute?.includes('Size') ?
    //       (lineStartY + (lineHeight * 2) + 4) : lineStartY
    // // Adjust position for the Color field
    //       const colorStartY = colorYStart;
    //       if(attribute?.includes('ColorName')){
    //         doc.text(
    //           `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '').slice(0, 3).join('/ ')}`,
    //           centerX - 12,
    //           colorStartY
    //         );
    //       }
    //       if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
    //         const netWtStartY = colorStartY + lineHeight * 2  ; // Position for NetWt row
    //         const netWtValues = data.NetWt.filter(netWt => netWt !== 0).slice(0, 3).join('/ ');
    //         doc.text(
    //           `${label[0].attributes.NetWgt}   :   ${netWtValues}`,
    //           centerX - 12,
    //           netWtStartY
    //         );
    //       }
    // Show all colors (joined by commas)
    let colorYStart =
      data.Dimension.length >= 3 && attribute?.includes('Size')
        ? lineStartY + lineHeight * 2 + 4
        : data.Dimension.length == 2
        ? lineStartY + lineHeight * 1 + 2
        : lineStartY;

    // Adjust position for the Color field
    if (attribute?.includes('ColorName')) {
      doc.text(
        `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '')
          .slice(0, 3)
          .join('/ ')}`,
        centerX - 12,
        colorYStart
      );
    }
    if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
      let netWtStartY = attribute?.includes('ColorName')
        ? colorYStart + lineHeight * 2
        : colorYStart;

      // Filter valid NetWt values (non-empty, non-zero strings)
      const validNetWtValues = data.NetWt.filter(
        netWt => String(netWt).trim() !== '0' && String(netWt).trim() !== ''
      );

      // Display NetWt values if valid ones exist
      if (validNetWtValues.length > 0) {
        const netWtValues = validNetWtValues.slice(0, 3).join('/ '); // Join valid values
        doc.text(`${label[0].attributes.NetWgt}   :   ${netWtValues}`, centerX - 12, netWtStartY);
      } else {
        // Show label only if no valid NetWt values
        doc.text(`${label[0].attributes.NetWgt}   :`, centerX - 12, netWtStartY);
      }
    }
    productCount++;
  }
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (print) {
    // Open the PDF in a new tab for printing
    window.open(blobUrl, '_blank');
  } else {
    // Create a download link for the PDF
    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = 'Product_List.pdf';
    downloadLink.click();
  }
  // setIsLoading3(false)
  // Revoke blob URL after some time to free up memory
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  return doc;
};

const generatePDF3v2 = async (cata, selectedRowIds, attribute, label) => {
  const doc = new jsPDF('landscape');
  // console.log('Attributes : ', attribute);
  const reversedCata = [
    ...cata.sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    })
  ];
  // Filter the products based on selectedRowIds
  const filteredData = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .map(product => {
      const { CoverImage, ProductId, Length, Width, Height, SizeUnit, SetStatus, SetSizes } =
        product;

      // Start with the basic product data
      const mappedProduct = {
        CoverImage: ip + product.attributes.CoverImage?.data?.attributes?.url || 'No Image',
        ProductId: product.attributes.ProductId || 'No AliasCode',
        SizeUnit: product.attributes.SizeUnit || 'N/A'
      };

      // If SetStatus is 'Set', check for SetSizes
      if (product.attributes.SetStatus === 'Set') {
        if (product.attributes.SetSizes && product.attributes.SetSizes.length > 0) {
          // If SetSizes exists and is not empty, map the SetSizes dimensions and include Description and ColorName
          mappedProduct.Dimension = product.attributes.SetSizes.map(size => {
            return `${size.Description ? size.Description + ' - ' : ''}${size.Length || 0} x ${
              size.Width || 0
            } x ${size.Height || 0} ${size.SizeUnit}`;
          });
          mappedProduct.ColorInfo = product.attributes.SetSizes.map(size =>
            size.ColorName ? size.ColorName : ' '
          );
          mappedProduct.NetWt = product.attributes.SetSizes.map(size =>
            size.NetWt ? size.NetWt : ' '
          );
        } else {
          // If SetSizes is empty, fallback to the main product's dimensions with Description and ColorName
          mappedProduct.Dimension = [
            `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '} `
          ];
          mappedProduct.ColorInfo = product.attributes.ColorName
            ? [product.attributes.ColorName]
            : [' '];
          mappedProduct.NetWt = product.attributes.NetWeight
            ? [product.attributes.NetWeight]
            : [' '];
        }
      } else {
        const { Length, Height, Width, SizeUnit } = product.attributes;
        // If SetStatus is not 'Set', directly use the product's dimensions with Description and ColorName
        mappedProduct.Dimension = [
          `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '}`
        ];
        mappedProduct.ColorInfo = product.attributes.ColorName
          ? [product.attributes.ColorName]
          : [' '];
        mappedProduct.NetWt = product.attributes.NetWeight ? [product.attributes.NetWeight] : [' '];
      }

      return mappedProduct;
    });

  const imageWidth = 100 * 1.05; // Increase image width by 15%
  const imageHeight = 100 * 1.05; // Image height adjusted to 80% of the original size
  const xOffset = 30; // Left margin for the first column
  const yOffset = 30; // Top margin for the first row
  const xSpacing = 120; // Horizontal space between columns
  const ySpacing = imageHeight + 20; // Vertical space between rows
  const maxProductsPerPage = 2; // 3x3 grid
  let productCount = 0; // Track the number of products on the current page

  const lineHeight = 2; // Line height for text

  // Iterate through the filtered data and add each product to the PDF
  for (let index = 0; index < filteredData.length; index++) {
    const data = filteredData[index];

    // Add a new page if the current page is full (9 products)
    if (productCount >= maxProductsPerPage) {
      doc.addPage();
      productCount = 0;
    }

    // Calculate the row and column for the current product in the 3x3 grid
    const row = Math.floor(productCount / 3); // 3 columns per row
    const col = productCount % 3; // 3 rows per page

    const xPos = xOffset + col * xSpacing; // X position for the current column
    const yPos = yOffset + row * ySpacing; // Y position for the current row

    const detailsXPos = xPos + imageWidth + 10; // Position for product details

    // Add product image
    if (data.CoverImage !== 'No Image') {
      try {
        // Fetch the image as base64
        const img = await fetchImageAsBase64(data.CoverImage);

        // Create an image element
        const imgElement = new Image();
        imgElement.src = img;

        // Wait for the image to load before adding it to the PDF
        await new Promise((resolve, reject) => {
          imgElement.onload = () => {
            const imgAspectRatio = imgElement.width / imgElement.height;

            // Calculate the scaled width and height to maintain the aspect ratio
            let scaledWidth = imageWidth;
            let scaledHeight = imageWidth / imgAspectRatio;

            // If the scaled height exceeds the container height, adjust to fit
            if (scaledHeight > imageHeight) {
              scaledHeight = imageHeight;
              scaledWidth = imageHeight * imgAspectRatio;
            }

            // Ensure the image doesn't exceed the container dimensions
            scaledWidth = Math.min(scaledWidth, imageWidth); // Constrain to container width
            scaledHeight = Math.min(scaledHeight, imageHeight); // Constrain to container height

            // Calculate the X and Y positions to center the image within the container
            const imageXPos = xPos + (imageWidth - scaledWidth) / 2; // Center the image horizontally
            const imageYPos = yPos + (imageHeight - scaledHeight) / 2; // Center the image vertically

            // Add the image to the PDF with the new width, height, and centered position
            doc.addImage(img, 'JPEG', imageXPos, imageYPos, scaledWidth, scaledHeight);

            resolve(); // Resolve the promise once the image is added
          };

          imgElement.onerror = reject; // Reject the promise if there's an error loading the image
        });
      } catch (error) {
        console.log('Error fetching image:', error);
        doc.text('Image Failed', xPos, yPos); // Fallback text if image loading fails
      }
    } else {
      doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    }

    // Add product details to the right of the image
    doc.setFontSize(9); // Font size for product details

    const detailsY = yPos + imageHeight + 5; // Adjusted vertical space for details

    // Format dimension string based on whether it's a single set or multiple sets
    const dimensionString = data.Dimension.join(' \n '); // Join dimensions into one string if there are multiple sets

    // Calculate the width of the text box for centering the text horizontally
    const textWidth = doc.getTextWidth(`AliasCode: ${data.ProductId}`);
    const centerX = xPos + (imageWidth - textWidth) / 2;

    if (attribute?.includes('ProductId') && label?.[0]?.attributes?.AliasCode && data?.ProductId) {
      doc.text(`${label[0].attributes.AliasCode} :   ${data.ProductId}`, centerX - 12, detailsY);
    }
    if (attribute?.includes('Size')) {
      doc.text(`Size        :`, centerX - 12, detailsY + lineHeight * 2);
    }

    // We will calculate where to position the color info
    const dimensionStartY = detailsY + lineHeight * 2; // Start a bit lower than the label

    // Print the first dimension inline with the "Dimension:" label
    const firstDimension = data.Dimension[0];
    // const firstNetWt = data.NetWt?.[0] > 0 ? `- ${data.NetWt[0]}` : '';

    if (attribute?.includes('Size')) {
      doc.text(`${firstDimension} `, centerX + 4, dimensionStartY); // First dimension inline
    }

    // Print remaining dimensions on subsequent lines, with indentation
    let lineStartY = dimensionStartY + lineHeight * 2; // Space for the next line of dimensions
    lineStartY = attribute?.includes('Size') ? dimensionStartY + lineHeight * 2 : dimensionStartY;
    if (attribute?.includes('Size')) {
      let i = 0;
      data.Dimension.slice(1).forEach((dimension, idx) => {
        if (i < 2) {
          // const netWeight = data.NetWt?.[idx + 1] ? `- ${data.NetWt[idx + 1]}` : '';
          const lineY = lineStartY + idx * (lineHeight * 2);
          doc.text(`${dimension}`, centerX + 4, lineY);
          i++;
        }
      });
    }

    // Adjust position for the Color field
    // const colorStartY = lineStartY + (data.Dimension.length - 1) * (lineHeight * 2) + 1; // Adding 2 for a small space after dimensions
    //       let colorYStart = data.Dimension.length >= 3 && attribute?.includes('Size') ?
    //       (lineStartY + (lineHeight * 2) + 4) : lineStartY
    // // Adjust position for the Color field
    //       let colorStartY = colorYStart ;

    //       if(attribute?.includes('ColorName')){
    //         doc.text(
    //           `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '').slice(0, 3).join('/ ')}`,
    //           centerX - 12,
    //           colorStartY
    //         );
    //       }
    //       // colorStartY = colorStartY + lineHeight * 2 ;
    //       if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
    //         const netWtStartY = colorStartY + lineHeight * 2; // Position for NetWt row
    //         const netWtValues = data.NetWt.filter(netWt => netWt !== 0).slice(0, 3).join('/ ');

    //         doc.text(
    //           `${label[0].attributes.NetWgt}   :   ${netWtValues}`,
    //           centerX - 12,
    //           netWtStartY
    //         );
    //       }
    let colorYStart =
      data.Dimension.length >= 3 && attribute?.includes('Size')
        ? lineStartY + lineHeight * 2 + 4
        : data.Dimension.length == 2
        ? lineStartY + lineHeight * 1 + 2
        : lineStartY;

    // Adjust position for the Color field
    if (attribute?.includes('ColorName')) {
      doc.text(
        `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '')
          .slice(0, 3)
          .join('/ ')}`,
        centerX - 12,
        colorYStart
      );
    }
    if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
      let netWtStartY = attribute?.includes('ColorName')
        ? colorYStart + lineHeight * 2
        : colorYStart;

      // Filter valid NetWt values (non-empty, non-zero strings)
      const validNetWtValues = data.NetWt.filter(
        netWt => String(netWt).trim() !== '0' && String(netWt).trim() !== ''
      );

      // Display NetWt values if valid ones exist
      if (validNetWtValues.length > 0) {
        const netWtValues = validNetWtValues.slice(0, 3).join('/ '); // Join valid values
        doc.text(`${label[0].attributes.NetWgt}   :   ${netWtValues}`, centerX - 12, netWtStartY);
      } else {
        // Show label only if no valid NetWt values
        doc.text(`${label[0].attributes.NetWgt}   :`, centerX - 12, netWtStartY);
      }
    }
    productCount++; // Move to the next product
  }
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (print) {
    // Open the PDF in a new tab for printing
    window.open(blobUrl, '_blank');
  } else {
    // Create a download link for the PDF
    const downloadLink = document.createElement('a');
    downloadLink.href = blobUrl;
    downloadLink.download = 'Product_List.pdf';
    downloadLink.click();
  }

  // Revoke blob URL after some time to free up memory
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  return doc;
};
const generatePDF3v3 = async (cata, selectedRowIds, attribute, label, setIsLoading3) => {
  const doc = new jsPDF('landscape');
  const reversedCata = [
    ...cata.sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    })
  ];
  // Filter the data
  const filteredData = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .map(product => {
      const { CoverImage, ProductId, Length, Width, Height, SizeUnit, SetStatus, SetSizes } =
        product;

      // Start with the basic product data
      const mappedProduct = {
        CoverImage: ip + product.attributes.CoverImage?.data?.attributes?.url || 'No Image',
        ProductId: product.attributes.ProductId || 'No AliasCode',
        SizeUnit: product.attributes.SizeUnit || 'N/A'
      };

      // If SetStatus is 'Set', check for SetSizes
      if (product.attributes.SetStatus === 'Set') {
        if (product.attributes.SetSizes && product.attributes.SetSizes.length > 0) {
          // If SetSizes exists and is not empty, map the SetSizes dimensions and include Description and ColorName
          mappedProduct.Dimension = product.attributes.SetSizes.map(size => {
            return `${size.Description ? size.Description + ' - ' : ''}${size.Length || 0} x ${
              size.Width || 0
            } x ${size.Height || 0} ${size.SizeUnit}`;
          });
          mappedProduct.ColorInfo = product.attributes.SetSizes.map(size =>
            size.ColorName ? size.ColorName : ' '
          );
          mappedProduct.NetWt = product.attributes.SetSizes.map(size =>
            size.NetWt ? size.NetWt : ' '
          );
        } else {
          // If SetSizes is empty, fallback to the main product's dimensions with Description and ColorName
          mappedProduct.Dimension = [
            `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '} `
          ];
          mappedProduct.ColorInfo = product.attributes.ColorName
            ? [product.attributes.ColorName]
            : [' '];
          mappedProduct.NetWt = product.attributes.NetWeight
            ? [product.attributes.NetWeight]
            : [' '];
        }
      } else {
        const { Length, Height, Width, SizeUnit } = product.attributes;
        // If SetStatus is not 'Set', directly use the product's dimensions with Description and ColorName
        mappedProduct.Dimension = [
          `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '}`
        ];
        mappedProduct.ColorInfo = product.attributes.ColorName
          ? [product.attributes.ColorName]
          : [' '];

        mappedProduct.NetWt = product.attributes.NetWeight ? [product.attributes.NetWeight] : [' '];
      }

      return mappedProduct;
    });

  // Set initial position and layout for a 3x3 grid
  const imageWidth = 80 * 1.05; // Increase image width by 15%
  const imageHeight = 80 * 1.05; // Reduce image height to 50px (80% of 50px)
  const xOffset = 14; // Left margin for the first column
  const yOffset = 40; // Top margin for the first row (reduced by 10 units from 30)

  const xSpacing = 90; // Horizontal space between columns (adjusted to make it dynamic)
  const ySpacing = imageHeight + 20; // Vertical space between rows (space between products)

  const maxProductsPerPage = 3; // 3x3 grid (3 columns, 3 rows)
  let productCount = 0; // Track the number of products added on the current page

  const lineHeight = 2; // Line height for product details

  // Iterate through the filtered data and add each product to the PDF
  for (let index = 0; index < filteredData.length; index++) {
    const data = filteredData[index];

    // Add a new page if the current page is full (9 products)
    if (productCount >= maxProductsPerPage) {
      doc.addPage(); // Start a new page
      productCount = 0; // Reset the product counter
    }

    // Calculate the row and column for the current product in the 3x3 grid
    const row = Math.floor(productCount / 3); // 3 columns per row
    const col = productCount % 3; // 3 rows per page

    const xPos = xOffset + col * xSpacing; // Calculate x position for the current column
    const yPos = yOffset + row * ySpacing; // Calculate y position for the current row

    const detailsXPos = xPos + imageWidth + 10; // Position for the product details to the right of the image

    // Add product image
    // if (data.CoverImage !== 'No Image') {
    //   try {
    //     const img = await fetchImageAsBase64(data.CoverImage);
    //     doc.addImage(img, 'JPEG', xPos, yPos, imageWidth, imageHeight); // Add image
    //   } catch (error) {
    //     console.log('Error fetching image', error);
    //     doc.text('Image Failed', xPos, yPos); // Fallback in case of an error
    //   }
    // } else {
    //   doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    // }
    if (data.CoverImage !== 'No Image') {
      try {
        // Fetch the image as base64
        const img = await fetchImageAsBase64(data.CoverImage);

        // Create an image element
        const imgElement = new Image();
        imgElement.src = img;

        // Wait for the image to load before adding it to the PDF
        await new Promise((resolve, reject) => {
          imgElement.onload = () => {
            const imgAspectRatio = imgElement.width / imgElement.height;

            // Calculate the scaled width and height to maintain the aspect ratio
            let scaledWidth = imageWidth;
            let scaledHeight = imageWidth / imgAspectRatio;

            // If the scaled height exceeds the container height, adjust to fit
            if (scaledHeight > imageHeight) {
              scaledHeight = imageHeight;
              scaledWidth = imageHeight * imgAspectRatio;
            }

            // Ensure the image doesn't exceed the container dimensions
            scaledWidth = Math.min(scaledWidth, imageWidth); // Constrain to container width
            scaledHeight = Math.min(scaledHeight, imageHeight); // Constrain to container height

            // Calculate the X and Y positions to center the image within the container
            const imageXPos = xPos + (imageWidth - scaledWidth) / 2; // Center the image horizontally
            const imageYPos = yPos + (imageHeight - scaledHeight) / 2; // Center the image vertically

            // Add the image to the PDF with the new width, height, and centered position
            doc.addImage(img, 'JPEG', imageXPos, imageYPos, scaledWidth, scaledHeight);

            resolve(); // Resolve the promise once the image is added
          };

          imgElement.onerror = reject; // Reject the promise if there's an error loading the image
        });
      } catch (error) {
        console.log('Error fetching image:', error);
        doc.text('Image Failed', xPos, yPos); // Fallback text if image loading fails
      }
    } else {
      doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    }
    // Add product details to the right of the image
    doc.setFontSize(9); // Font size set to 9 for product details

    // Add a gap of 5 units between the image and the details
    const detailsY = yPos + imageHeight + 5; // Adjusted vertical space to create a 5-unit gap
    const dimensionString = data.Dimension.join(' \n ');

    const textWidth = doc.getTextWidth(`AliasCode: ${data.ProductId}`);
    const centerX = xPos + (imageWidth - textWidth) / 2;

    if (attribute?.includes('ProductId') && label?.[0]?.attributes?.AliasCode && data?.ProductId) {
      doc.text(`${label[0].attributes.AliasCode} :   ${data.ProductId}`, centerX - 12, detailsY);
    }
    if (attribute?.includes('Size')) {
      doc.text(`Size        :`, centerX - 12, detailsY + lineHeight * 2);
    }

    // We will calculate where to position the color info
    const dimensionStartY = detailsY + lineHeight * 2; // Start a bit lower than the label

    // Print the first dimension inline with the "Dimension:" label
    const firstDimension = data.Dimension[0];
    // const firstNetWt = data.NetWt?.[0] > 0 ? `- ${data.NetWt[0]}` : '';
    if (attribute?.includes('Size')) {
      doc.text(`${firstDimension} `, centerX + 4, dimensionStartY); // First dimension inline
    }

    // Print remaining dimensions on subsequent lines, with indentation
    let lineStartY = dimensionStartY + lineHeight * 2; // Space for the next line of dimensions
    lineStartY = attribute?.includes('Size') ? dimensionStartY + lineHeight * 2 : dimensionStartY;

    if (attribute?.includes('Size')) {
      let i = 0;
      data.Dimension.slice(1).forEach((dimension, idx) => {
        if (i < 2) {
          // const netWeight = data.NetWt?.[idx + 1] ? `- ${data.NetWt[idx + 1]}` : '';
          const lineY = lineStartY + idx * (lineHeight * 2);
          doc.text(`${dimension}`, centerX + 4, lineY);
          i++;
        }
      });
    }

    // Adjust position for the Color field
    // const colorStartY = lineStartY + (data.Dimension.length - 1) * (lineHeight * 2) + 1; // Adding 2 for a small space after dimensions
    // let colorYStart = data.Dimension.length >= 3 && attribute?.includes('Size') ?
    // (lineStartY + (lineHeight * 2) + 4) : lineStartY
    // const colorStartY = colorYStart;

    // if(attribute?.includes('ColorName')){
    //   doc.text(
    //     `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '').slice(0, 3).join('/ ')}`,
    //     centerX - 12,
    //     colorStartY
    //   );
    // }
    // if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
    //   const netWtStartY = colorStartY + lineHeight * 2; // Position for NetWt row
    //   const netWtValues = data.NetWt.filter(netWt => netWt !== 0).slice(0, 3).join('/ ');

    //   doc.text(
    //     `${label[0].attributes.NetWgt}   :   ${netWtValues}`,
    //     centerX - 12,
    //     netWtStartY
    //   );
    // }
    let colorYStart =
      data.Dimension.length >= 3 && attribute?.includes('Size')
        ? lineStartY + lineHeight * 2 + 4
        : data.Dimension.length == 2
        ? lineStartY + lineHeight * 1 + 2
        : lineStartY;

    // Adjust position for the Color field
    if (attribute?.includes('ColorName')) {
      doc.text(
        `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '')
          .slice(0, 3)
          .join('/ ')}`,
        centerX - 12,
        colorYStart
      );
    }
    if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
      let netWtStartY = attribute?.includes('ColorName')
        ? colorYStart + lineHeight * 2
        : colorYStart;

      // Filter valid NetWt values (non-empty, non-zero strings)
      const validNetWtValues = data.NetWt.filter(
        netWt => String(netWt).trim() !== '0' && String(netWt).trim() !== ''
      );

      // Display NetWt values if valid ones exist
      if (validNetWtValues.length > 0) {
        const netWtValues = validNetWtValues.slice(0, 3).join('/ '); // Join valid values
        doc.text(`${label[0].attributes.NetWgt}   :   ${netWtValues}`, centerX - 12, netWtStartY);
      } else {
        // Show label only if no valid NetWt values
        doc.text(`${label[0].attributes.NetWgt}   :`, centerX - 12, netWtStartY);
      }
    }
    // Move to the next product
    productCount++;
  }
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (print) {
    // If the action is 'Print', open PDF in a new window
    window.open(blobUrl, '_blank');
  } else {
    // If the action is 'Download', trigger the PDF download
    doc.save('Format3_PDF.pdf');
  }

  setIsLoading3(false);

  // Revoke blob URL after some time to free up memory
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  return doc;
};
const generatePDF3v4 = async (cata, selectedRowIds, attribute, label, setIsLoading3) => {
  const doc = new jsPDF('landscape');
  const reversedCata = [
    ...cata.sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    })
  ];
  // Filter the data
  const filteredData = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .map(product => {
      const { CoverImage, ProductId, Length, Width, Height, SizeUnit, SetStatus, SetSizes } =
        product;

      // Start with the basic product data
      const mappedProduct = {
        CoverImage: ip + product.attributes.CoverImage?.data?.attributes?.url || 'No Image',
        ProductId: product.attributes.ProductId || 'No AliasCode',
        SizeUnit: product.attributes.SizeUnit || 'N/A'
      };

      // If SetStatus is 'Set', check for SetSizes
      if (product.attributes.SetStatus === 'Set') {
        if (product.attributes.SetSizes && product.attributes.SetSizes.length > 0) {
          mappedProduct.Dimension = product.attributes.SetSizes.map(size => {
            return `${size.Description ? size.Description + ' - ' : ''}${size.Length || 0} x ${
              size.Width || 0
            } x ${size.Height || 0} ${size.SizeUnit}`;
          });
          mappedProduct.ColorInfo = product.attributes.SetSizes.map(size =>
            size.ColorName ? size.ColorName : ' '
          );
          mappedProduct.NetWt = product.attributes.SetSizes.map(size =>
            size.NetWt ? size.NetWt : ' '
          );
        } else {
          mappedProduct.Dimension = [
            `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '}`
          ];
          mappedProduct.ColorInfo = product.attributes.ColorName
            ? [product.attributes.ColorName]
            : [' '];
          mappedProduct.NetWt = product.attributes.NetWeight
            ? [product.attributes.NetWeight]
            : [' '];
        }
      } else {
        const { Length, Height, Width, SizeUnit } = product.attributes;
        mappedProduct.Dimension = [
          `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '}`
        ];
        mappedProduct.ColorInfo = product.attributes.ColorName
          ? [product.attributes.ColorName]
          : [' '];
        mappedProduct.NetWt = product.attributes.NetWeight ? [product.attributes.NetWeight] : [' '];
      }
      return mappedProduct;
    });

  // Set initial position and layout for a custom grid
  const imageWidth = 80 * 0.8; // Image width (80% of 90px)
  const imageHeight = 80 * 0.8; // Image height (80% of 90px)
  const xOffset = 60; // Left margin for the first column
  const yOffset = 15; // Top margin for the first row

  const xSpacing = 120; // Horizontal space between columns (space for 2 products per row)
  const ySpacing = imageHeight + 30; // Vertical space between rows (space between products)

  const maxProductsPerPage = 4; // Max products to be displayed per page (2x2 grid)
  let productCount = 0; // Track the number of products added on the current page

  const lineHeight = 2; // Line height for product details

  // Iterate through the filtered data and add each product to the PDF
  for (let index = 0; index < filteredData.length; index++) {
    const data = filteredData[index];

    // Add a new page if the current page is full (4 products)
    if (productCount >= maxProductsPerPage) {
      doc.addPage(); // Start a new page
      productCount = 0; // Reset the product counter
    }

    // Custom Layout
    // First row: 2 products
    // Second row: 2 products

    let xPos = 0;
    let yPos = 0;

    if (productCount < 2) {
      // First row: 2 products
      xPos = xOffset + (productCount % 2) * xSpacing; // 2 products in the first row
      yPos = yOffset;
    } else if (productCount >= 2 && productCount < 4) {
      // Second row: 2 products
      xPos = xOffset + ((productCount - 2) % 2) * xSpacing; // 2 products in the second row
      yPos = yOffset + ySpacing;
    }

    const detailsXPos = xPos + imageWidth + 10; // Position for the product details to the right of the image

    // Add product image
    // if (data.CoverImage !== 'No Image') {
    //   try {
    //     const img = await fetchImageAsBase64(data.CoverImage);
    //     doc.addImage(img, 'JPEG', xPos, yPos, imageWidth, imageHeight); // Add image
    //   } catch (error) {
    //     console.log('Error fetching image', error);
    //     doc.text('Image Failed', xPos, yPos); // Fallback in case of an error
    //   }
    // } else {
    //   doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    // }
    if (data.CoverImage !== 'No Image') {
      try {
        // Fetch the image as base64
        const img = await fetchImageAsBase64(data.CoverImage);

        // Create an image element
        const imgElement = new Image();
        imgElement.src = img;

        // Wait for the image to load before adding it to the PDF
        await new Promise((resolve, reject) => {
          imgElement.onload = () => {
            const imgAspectRatio = imgElement.width / imgElement.height;

            // Calculate the scaled width and height to maintain the aspect ratio
            let scaledWidth = imageWidth;
            let scaledHeight = imageWidth / imgAspectRatio;

            // If the scaled height exceeds the container height, adjust to fit
            if (scaledHeight > imageHeight) {
              scaledHeight = imageHeight;
              scaledWidth = imageHeight * imgAspectRatio;
            }

            // Ensure the image doesn't exceed the container dimensions
            scaledWidth = Math.min(scaledWidth, imageWidth); // Constrain to container width
            scaledHeight = Math.min(scaledHeight, imageHeight); // Constrain to container height

            // Calculate the X and Y positions to center the image within the container
            const imageXPos = xPos + (imageWidth - scaledWidth) / 2; // Center the image horizontally
            const imageYPos = yPos + (imageHeight - scaledHeight) / 2; // Center the image vertically

            // Add the image to the PDF with the new width, height, and centered position
            doc.addImage(img, 'JPEG', imageXPos, imageYPos, scaledWidth, scaledHeight);

            resolve(); // Resolve the promise once the image is added
          };

          imgElement.onerror = reject; // Reject the promise if there's an error loading the image
        });
      } catch (error) {
        console.log('Error fetching image:', error);
        doc.text('Image Failed', xPos, yPos); // Fallback text if image loading fails
      }
    } else {
      doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    }
    // Add product details to the right of the image
    doc.setFontSize(9); // Font size set to 9 for product details

    // Add a gap of 5 units between the image and the details
    const detailsY = yPos + imageHeight + 5; // Adjusted vertical space to create a 5-unit gap
    const dimensionString = data.Dimension.join(' \n ');
    // Calculate the width of the text box to center the text horizontally
    const textWidth = doc.getTextWidth(`AliasCode: ${data.ProductId}`);
    const centerX = xPos + (imageWidth - textWidth) / 2;

    if (attribute?.includes('ProductId') && label?.[0]?.attributes?.AliasCode && data?.ProductId) {
      doc.text(`${label[0].attributes.AliasCode} :   ${data.ProductId}`, centerX - 12, detailsY);
    }
    if (attribute?.includes('Size')) {
      doc.text(`Size        :`, centerX - 12, detailsY + lineHeight * 2);
    }

    const dimensionStartY = detailsY + lineHeight * 2; // Start a bit lower than the label
    const lineIndentation = -3; // Indentation for each subsequent dimension string

    // Print the first dimension inline with the "Dimension:" label
    const firstDimension = data.Dimension[0];
    // const firstNetWt = data.NetWt?.[0] > 0 ? `- ${data.NetWt[0]}` : '';
    if (attribute?.includes('Size')) {
      doc.text(`${firstDimension} `, centerX + 4, dimensionStartY); // First dimension inline
    }

    // Print remaining dimensions on subsequent lines, with indentation
    let lineStartY = dimensionStartY + lineHeight * 2; // Space for the next line of dimensions
    lineStartY = attribute?.includes('Size') ? dimensionStartY + lineHeight * 2 : dimensionStartY;

    if (attribute?.includes('Size')) {
      let i = 0;
      data.Dimension.slice(1).forEach((dimension, idx) => {
        if (i < 2) {
          // const netWeight = data.NetWt?.[idx + 1] ? `- ${data.NetWt[idx + 1]}` : '';
          const lineY = lineStartY + idx * (lineHeight * 2);
          doc.text(`${dimension}`, centerX + 4, lineY);
          i++;
        }
      });
    }

    let colorYStart =
      data.Dimension.length >= 3 && attribute?.includes('Size')
        ? lineStartY + lineHeight * 2 + 4
        : data.Dimension.length == 2
        ? lineStartY + lineHeight * 1 + 2
        : lineStartY;

    // Adjust position for the Color field
    if (attribute?.includes('ColorName')) {
      doc.text(
        `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '')
          .slice(0, 3)
          .join('/ ')}`,
        centerX - 12,
        colorYStart
      );
    }
    if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
      let netWtStartY = attribute?.includes('ColorName')
        ? colorYStart + lineHeight * 2
        : colorYStart;

      // Filter valid NetWt values (non-empty, non-zero strings)
      const validNetWtValues = data.NetWt.filter(
        netWt => String(netWt).trim() !== '0' && String(netWt).trim() !== ''
      );

      // Display NetWt values if valid ones exist
      if (validNetWtValues.length > 0) {
        const netWtValues = validNetWtValues.slice(0, 3).join('/ '); // Join valid values
        doc.text(`${label[0].attributes.NetWgt}   :   ${netWtValues}`, centerX - 12, netWtStartY);
      } else {
        // Show label only if no valid NetWt values
        doc.text(`${label[0].attributes.NetWgt}   :`, centerX - 12, netWtStartY);
      }
    }
    // Move to the next product
    productCount++;
  }
  // Generate Blob file
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (print) {
    // If the action is 'Print', open PDF in a new window
    window.open(blobUrl, '_blank');
  } else {
    // If the action is 'Download', trigger the PDF download
    doc.save('Format4_PDF.pdf');
  }

  // Revoke the Blob URL after 1 minute to free up memory
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);

  setIsLoading3(false); // Optional, to hide a loading spinner or similar
  return doc;
};
const generatePDF3v5 = async (cata, selectedRowIds, attribute, label) => {
  const doc = new jsPDF('landscape');
  const reversedCata = [
    ...cata.sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    })
  ];
  // Filter the data
  const filteredData = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .map(product => {
      const { CoverImage, ProductId, Length, Width, Height, SizeUnit, SetStatus, SetSizes } =
        product;

      // Start with the basic product data
      const mappedProduct = {
        CoverImage: ip + product.attributes.CoverImage?.data?.attributes?.url || 'No Image',
        ProductId: product.attributes.ProductId || 'No AliasCode',
        SizeUnit: product.attributes.SizeUnit || 'N/A'
      };

      // If SetStatus is 'Set', check for SetSizes
      if (product.attributes.SetStatus === 'Set') {
        if (product.attributes.SetSizes && product.attributes.SetSizes.length > 0) {
          // If SetSizes exists and is not empty, map the SetSizes dimensions and include Description and ColorName
          mappedProduct.Dimension = product.attributes.SetSizes.map(size => {
            return `${size.Description ? size.Description + ' - ' : ''}${size.Length || 0} x ${
              size.Width || 0
            } x ${size.Height || 0} ${size.SizeUnit}`;
          });
          mappedProduct.ColorInfo = product.attributes.SetSizes.map(size =>
            size.ColorName ? size.ColorName : ' '
          );
          mappedProduct.NetWt = product.attributes.SetSizes.map(size =>
            size.NetWt ? size.NetWt : ' '
          );
        } else {
          // If SetSizes is empty, fallback to the main product's dimensions with Description and ColorName
          mappedProduct.Dimension = [
            `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '} `
          ];
          mappedProduct.NetWt = product.attributes.NetWeight
            ? [product.attributes.NetWeight]
            : [' '];
        }
      } else {
        // If SetStatus is not 'Set', directly use the product's dimensions with Description and ColorName
        const { Length, Height, Width, SizeUnit } = product.attributes;
        mappedProduct.Dimension = [
          `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '}`
        ];
        mappedProduct.ColorInfo = product.attributes.ColorName
          ? [product.attributes.ColorName]
          : [' '];
        mappedProduct.NetWt = product.attributes.NetWeight ? [product.attributes.NetWeight] : [' '];
      }
      return mappedProduct;
    });

  // Set initial position and layout for a custom grid
  const imageWidth = 80 * 0.8; // Image width (80% of 90px)
  const imageHeight = 80 * 0.8; // Image height (80% of 90px)
  const xOffset = 25; // Left margin for the first column
  const yOffset = 15; // Top margin for the first row

  const xSpacing = 90; // Horizontal space between columns
  const ySpacing = imageHeight + 40; // Vertical space between rows (space between products)

  const maxProductsPerPage = 5; // Max products to be displayed per page
  let productCount = 0; // Track the number of products added on the current page

  const lineHeight = 2; // Line height for product details

  // Iterate through the filtered data and add each product to the PDF
  for (let index = 0; index < filteredData.length; index++) {
    const data = filteredData[index];

    // Add a new page if the current page is full (5 products)
    if (productCount >= maxProductsPerPage) {
      doc.addPage(); // Start a new page
      productCount = 0; // Reset the product counter
    }

    // Custom Layout
    let xPos = 0;
    let yPos = 0;

    if (productCount < 3) {
      // First row: 3 products
      xPos = xOffset + (productCount % 3) * (xSpacing + 10); // 3 products in the first row
      yPos = yOffset;
    } else if (productCount >= 3 && productCount < 5) {
      // Second row: 2 products (centered with equal margins on both sides)
      const totalWidthOfProducts = 2 * imageWidth; // Total width of 2 products
      const availableSpace = doc.internal.pageSize.width - 2 * xOffset; // Available space between left and right margins
      const spaceBetweenProducts = (availableSpace - totalWidthOfProducts) / 3; // Distribute the remaining space equally on the left and right of the products

      // Calculate the starting x position to center the products
      xPos =
        xOffset + spaceBetweenProducts + (productCount - 3) * (imageWidth + spaceBetweenProducts);
      yPos = yOffset + ySpacing;
    }

    const detailsXPos = xPos + imageWidth + 10; // Position for the product details to the right of the image

    // Add product image
    if (data.CoverImage !== 'No Image') {
      try {
        // Fetch the image as base64
        const img = await fetchImageAsBase64(data.CoverImage);

        // Create an image element
        const imgElement = new Image();
        imgElement.src = img;

        // Wait for the image to load before adding it to the PDF
        await new Promise((resolve, reject) => {
          imgElement.onload = () => {
            const imgAspectRatio = imgElement.width / imgElement.height;

            // Calculate the scaled width and height to maintain the aspect ratio
            let scaledWidth = imageWidth;
            let scaledHeight = imageWidth / imgAspectRatio;

            // If the scaled height exceeds the container height, adjust to fit
            if (scaledHeight > imageHeight) {
              scaledHeight = imageHeight;
              scaledWidth = imageHeight * imgAspectRatio;
            }

            // Ensure the image doesn't exceed the container dimensions
            scaledWidth = Math.min(scaledWidth, imageWidth); // Constrain to container width
            scaledHeight = Math.min(scaledHeight, imageHeight); // Constrain to container height

            // Calculate the X and Y positions to center the image within the container
            const imageXPos = xPos + (imageWidth - scaledWidth) / 2; // Center the image horizontally
            const imageYPos = yPos + (imageHeight - scaledHeight) / 2; // Center the image vertically

            // Add the image to the PDF with the new width, height, and centered position
            doc.addImage(img, 'JPEG', imageXPos, imageYPos, scaledWidth, scaledHeight);

            resolve(); // Resolve the promise once the image is added
          };

          imgElement.onerror = reject; // Reject the promise if there's an error loading the image
        });
      } catch (error) {
        console.log('Error fetching image:', error);
        doc.text('Image Failed', xPos, yPos); // Fallback text if image loading fails
      }
    } else {
      doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    }

    // Add product details to the right of the image
    doc.setFontSize(9); // Font size set to 9 for product details

    // Add a gap of 5 units between the image and the details
    const detailsY = yPos + imageHeight + 5; // Adjusted vertical space to create a 5-unit gap

    // Format the dimension string as: "Length x Width x Height SizeUnit"
    const dimensionString = data.Dimension.join(' \n ');

    const textWidth = doc.getTextWidth(`AliasCode: ${data.ProductId}`);
    const centerX = xPos + (imageWidth - textWidth) / 2;

    if (attribute?.includes('ProductId') && label?.[0]?.attributes?.AliasCode && data?.ProductId) {
      doc.text(`${label[0].attributes.AliasCode} :   ${data.ProductId}`, centerX - 12, detailsY);
    }
    if (attribute?.includes('Size')) {
      doc.text(`Size        :`, centerX - 12, detailsY + lineHeight * 2);
    }

    const dimensionStartY = detailsY + lineHeight * 2; // Start a bit lower than the label
    const lineIndentation = -3; // Indentation for each subsequent dimension string

    // Print the first dimension inline with the "Dimension:" label
    const firstDimension = data.Dimension[0];
    // const firstNetWt = data.NetWt?.[0] > 0 ? `- ${data.NetWt[0]}` : '';
    if (attribute?.includes('Size')) {
      doc.text(`${firstDimension} `, centerX + 4, dimensionStartY); // First dimension inline
    }

    // Print remaining dimensions on subsequent lines, with indentation
    let lineStartY = dimensionStartY + lineHeight * 2; // Space for the next line of dimensions
    lineStartY = attribute?.includes('Size') ? dimensionStartY + lineHeight * 2 : dimensionStartY;

    if (attribute?.includes('Size')) {
      let i = 0;
      data.Dimension.slice(1).forEach((dimension, idx) => {
        if (i < 2) {
          // const netWeight = data.NetWt?.[idx + 1] ? `- ${data.NetWt[idx + 1]}` : '';
          const lineY = lineStartY + idx * (lineHeight * 2);
          doc.text(`${dimension}`, centerX + 4, lineY);
          i++;
        }
      });
    }

    let colorYStart =
      data.Dimension.length >= 3 && attribute?.includes('Size')
        ? lineStartY + lineHeight * 2 + 4
        : data.Dimension.length == 2
        ? lineStartY + lineHeight * 1 + 2
        : lineStartY;

    // Adjust position for the Color field
    if (attribute?.includes('ColorName')) {
      doc.text(
        `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '')
          .slice(0, 3)
          .join('/ ')}`,
        centerX - 12,
        colorYStart
      );
    }
    if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
      let netWtStartY = attribute?.includes('ColorName')
        ? colorYStart + lineHeight * 2
        : colorYStart;

      // Filter valid NetWt values (non-empty, non-zero strings)
      const validNetWtValues = data.NetWt.filter(
        netWt => String(netWt).trim() !== '0' && String(netWt).trim() !== ''
      );

      // Display NetWt values if valid ones exist
      if (validNetWtValues.length > 0) {
        const netWtValues = validNetWtValues.slice(0, 3).join('/ '); // Join valid values
        doc.text(`${label[0].attributes.NetWgt}   :   ${netWtValues}`, centerX - 12, netWtStartY);
      } else {
        // Show label only if no valid NetWt values
        doc.text(`${label[0].attributes.NetWgt}   :`, centerX - 12, netWtStartY);
      }
    }
    // Move to the next product
    productCount++;
  }
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (print) {
    // If the action is 'Print', open PDF in a new window
    window.open(blobUrl, '_blank');
  } else {
    // If the action is 'Download', trigger the PDF download
    doc.save('Format5_PDF.pdf');
  }

  // Revoke blob URL after some time to free up memory
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);

  return doc;
};
const generatePDF3v6 = async (cata, selectedRowIds, attribute, label) => {
  const doc = new jsPDF('landscape');
  const reversedCata = [
    ...cata.sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    })
  ];
  // Filter the data
  const filteredData = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .map(product => {
      const { CoverImage, ProductId, Length, Width, Height, SizeUnit, SetStatus, SetSizes } =
        product;

      // Start with the basic product data
      const mappedProduct = {
        CoverImage: ip + product.attributes.CoverImage?.data?.attributes?.url || 'No Image',
        ProductId: product.attributes.ProductId || 'No AliasCode',
        SizeUnit: product.attributes.SizeUnit || 'N/A'
      };

      // If SetStatus is 'Set', check for SetSizes
      if (product.attributes.SetStatus === 'Set') {
        if (product.attributes.SetSizes && product.attributes.SetSizes.length > 0) {
          // If SetSizes exists and is not empty, map the SetSizes dimensions and include Description and ColorName
          mappedProduct.Dimension = product.attributes.SetSizes.map(size => {
            return `${size.Description ? size.Description + ' - ' : ''}${size.Length || 0} x ${
              size.Width || 0
            } x ${size.Height || 0} ${size.SizeUnit}`;
          });
          mappedProduct.ColorInfo = product.attributes.SetSizes.map(size =>
            size.ColorName ? size.ColorName : ' '
          );
          mappedProduct.NetWt = product.attributes.SetSizes.map(size =>
            size.NetWt ? size.NetWt : ' '
          );
        } else {
          // If SetSizes is empty, fallback to the main product's dimensions with Description and ColorName
          mappedProduct.Dimension = [
            `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '} `
          ];
          mappedProduct.ColorInfo = product.attributes.ColorName
            ? [product.attributes.ColorName]
            : [' '];
          mappedProduct.NetWt = product.attributes.NetWeight
            ? [product.attributes.NetWeight]
            : [' '];
        }
      } else {
        const { Length, Height, Width, SizeUnit } = product.attributes;
        // If SetStatus is not 'Set', directly use the product's dimensions with Description and ColorName
        mappedProduct.Dimension = [
          `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '}`
        ];
        mappedProduct.ColorInfo = product.attributes.ColorName
          ? [product.attributes.ColorName]
          : [' '];
        mappedProduct.NetWt = product.attributes.NetWeight ? [product.attributes.NetWeight] : [' '];
      }

      return mappedProduct;
    });

  // Set initial position and layout for a 3x3 grid
  const imageWidth = 90 * 0.6; // Reduce image width to 70px (80% of 70px)
  const imageHeight = 90 * 0.6; // Reduce image height to 50px (80% of 50px)
  const xOffset = 25; // Left margin for the first column
  const yOffset = 15; // Top margin for the first row (reduced by 10 units from 30)

  const xSpacing = 90; // Horizontal space between columns (adjusted to make it dynamic)
  const ySpacing = imageHeight + 35; // Vertical space between rows (space between products)

  const maxProductsPerPage = 6; // 3x3 grid (3 columns, 3 rows)
  let productCount = 0; // Track the number of products added on the current page

  const lineHeight = 2; // Line height for product details

  // Iterate through the filtered data and add each product to the PDF
  for (let index = 0; index < filteredData.length; index++) {
    const data = filteredData[index];

    // Add a new page if the current page is full (9 products)
    if (productCount >= maxProductsPerPage) {
      doc.addPage(); // Start a new page
      productCount = 0; // Reset the product counter
    }

    // Calculate the row and column for the current product in the 3x3 grid
    const row = Math.floor(productCount / 3); // 3 columns per row
    const col = productCount % 3; // 3 rows per page

    const xPos = xOffset + col * xSpacing; // Calculate x position for the current column
    const yPos = yOffset + row * ySpacing; // Calculate y position for the current row

    const detailsXPos = xPos + imageWidth + 10; // Position for the product details to the right of the image

    // Add product image
    if (data.CoverImage !== 'No Image') {
      try {
        // Fetch the image as base64
        const img = await fetchImageAsBase64(data.CoverImage);

        // Create an image element
        const imgElement = new Image();
        imgElement.src = img;

        // Wait for the image to load before adding it to the PDF
        await new Promise((resolve, reject) => {
          imgElement.onload = () => {
            const imgAspectRatio = imgElement.width / imgElement.height;

            // Calculate the scaled width and height to maintain the aspect ratio
            let scaledWidth = imageWidth;
            let scaledHeight = imageWidth / imgAspectRatio;

            // If the scaled height exceeds the container height, adjust to fit
            if (scaledHeight > imageHeight) {
              scaledHeight = imageHeight;
              scaledWidth = imageHeight * imgAspectRatio;
            }

            // Ensure the image doesn't exceed the container dimensions
            scaledWidth = Math.min(scaledWidth, imageWidth); // Constrain to container width
            scaledHeight = Math.min(scaledHeight, imageHeight); // Constrain to container height

            // Calculate the X and Y positions to center the image within the container
            const imageXPos = xPos + (imageWidth - scaledWidth) / 2; // Center the image horizontally
            const imageYPos = yPos + (imageHeight - scaledHeight) / 2; // Center the image vertically

            // Add the image to the PDF with the new width, height, and centered position
            doc.addImage(img, 'JPEG', imageXPos, imageYPos, scaledWidth, scaledHeight);

            resolve(); // Resolve the promise once the image is added
          };

          imgElement.onerror = reject; // Reject the promise if there's an error loading the image
        });
      } catch (error) {
        console.log('Error fetching image:', error);
        doc.text('Image Failed', xPos, yPos); // Fallback text if image loading fails
      }
    } else {
      doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    }

    // Add product details to the right of the image
    doc.setFontSize(9); // Font size set to 9 for product details

    // Add a gap of 5 units between the image and the details
    const detailsY = yPos + imageHeight + 5; // Adjusted vertical space to create a 5-unit gap
    const dimensionString = data.Dimension.join(' \n ');
    // Calculate the width of the text box to center the text horizontally
    const textWidth = doc.getTextWidth(`AliasCode: ${data.ProductId}`);
    const centerX = xPos + (imageWidth - textWidth) / 2;

    if (attribute?.includes('ProductId') && label?.[0]?.attributes?.AliasCode && data?.ProductId) {
      doc.text(`${label[0].attributes.AliasCode} :   ${data.ProductId}`, centerX - 12, detailsY);
    }
    if (attribute?.includes('Size')) {
      doc.text(`Size        :`, centerX - 12, detailsY + lineHeight * 2);
    }

    // We will calculate where to position the color info
    const dimensionStartY = detailsY + lineHeight * 2; // Start a bit lower than the label

    // Print the first dimension inline with the "Dimension:" label
    const firstDimension = data.Dimension[0];
    // const firstNetWt = data.NetWt?.[0] > 0 ? `- ${data.NetWt[0]}` : '';
    if (attribute?.includes('Size')) {
      doc.text(`${firstDimension} `, centerX + 4, dimensionStartY); // First dimension inline
    }

    // Print remaining dimensions on subsequent lines, with indentation
    let lineStartY = dimensionStartY + lineHeight * 2; // Space for the next line of dimensions
    lineStartY = attribute?.includes('Size') ? dimensionStartY + lineHeight * 2 : dimensionStartY;

    if (attribute?.includes('Size')) {
      let i = 0;
      data.Dimension.slice(1).forEach((dimension, idx) => {
        if (i < 2) {
          // const netWeight = data.NetWt?.[idx + 1] ? `- ${data.NetWt[idx + 1]}` : '';
          const lineY = lineStartY + idx * (lineHeight * 2);
          doc.text(`${dimension}`, centerX + 4, lineY);
          i++;
        }
      });
    }

    let colorYStart =
      data.Dimension.length >= 3 && attribute?.includes('Size')
        ? lineStartY + lineHeight * 2 + 4
        : data.Dimension.length == 2
        ? lineStartY + lineHeight * 1 + 2
        : lineStartY;

    // Adjust position for the Color field
    if (attribute?.includes('ColorName')) {
      doc.text(
        `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '')
          .slice(0, 3)
          .join('/ ')}`,
        centerX - 12,
        colorYStart
      );
    }
    if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
      let netWtStartY = attribute?.includes('ColorName')
        ? colorYStart + lineHeight * 2
        : colorYStart;

      // Filter valid NetWt values (non-empty, non-zero strings)
      const validNetWtValues = data.NetWt.filter(
        netWt => String(netWt).trim() !== '0' && String(netWt).trim() !== ''
      );

      // Display NetWt values if valid ones exist
      if (validNetWtValues.length > 0) {
        const netWtValues = validNetWtValues.slice(0, 3).join('/ '); // Join valid values
        doc.text(`${label[0].attributes.NetWgt}   :   ${netWtValues}`, centerX - 12, netWtStartY);
      } else {
        // Show label only if no valid NetWt values
        doc.text(`${label[0].attributes.NetWgt}   :`, centerX - 12, netWtStartY);
      }
    }
    // Move to the next product
    productCount++;
  }
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (print) {
    // If the action is 'Print', open PDF in a new window
    window.open(blobUrl, '_blank');
  } else {
    // If the action is 'Download', trigger the PDF download
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = 'Format6_PDF.pdf'; // Set the default filename for the download
    link.click();
  }

  // Revoke blob URL after some time to free up memory
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  return doc;
};
const generatePDF3v7 = async (cata, selectedRowIds, attribute, label) => {
  const doc = new jsPDF('landscape');
  const reversedCata = [
    ...cata.sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    })
  ];
  // Filter the data
  const filteredData = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .map(product => {
      const { CoverImage, ProductId, Length, Width, Height, SizeUnit, SetStatus, SetSizes } =
        product;

      // Start with the basic product data
      const mappedProduct = {
        CoverImage: ip + product.attributes.CoverImage?.data?.attributes?.url || 'No Image',
        ProductId: product.attributes.ProductId || 'No AliasCode',
        SizeUnit: product.attributes.SizeUnit || 'N/A'
      };

      // If SetStatus is 'Set', check for SetSizes
      if (product.attributes.SetStatus === 'Set') {
        if (product.attributes.SetSizes && product.attributes.SetSizes.length > 0) {
          // If SetSizes exists and is not empty, map the SetSizes dimensions and include Description and ColorName
          mappedProduct.Dimension = product.attributes.SetSizes.map(size => {
            return `${size.Description ? size.Description + ' - ' : ''}${size.Length || 0} x ${
              size.Width || 0
            } x ${size.Height || 0} ${size.SizeUnit}`;
          });
          mappedProduct.ColorInfo = product.attributes.SetSizes.map(size =>
            size.ColorName ? size.ColorName : ' '
          );
          mappedProduct.NetWt = product.attributes.SetSizes.map(size =>
            size.NetWt ? size.NetWt : ' '
          );
        } else {
          // If SetSizes is empty, fallback to the main product's dimensions with Description and ColorName
          mappedProduct.Dimension = [
            `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '} `
          ];
          mappedProduct.ColorInfo = product.attributes.ColorName
            ? [product.attributes.ColorName]
            : [' '];
          mappedProduct.NetWt = product.attributes.NetWeight
            ? [product.attributes.NetWeight]
            : [' '];
        }
      } else {
        const { Length, Height, Width, SizeUnit } = product.attributes;
        // If SetStatus is not 'Set', directly use the product's dimensions with Description and ColorName
        mappedProduct.Dimension = [
          `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '}`
        ];
        mappedProduct.ColorInfo = product.attributes.ColorName
          ? [product.attributes.ColorName]
          : [' '];
        mappedProduct.NetWt = product.attributes.NetWeight ? [product.attributes.NetWeight] : [' '];
      }

      return mappedProduct;
    });
  // Set initial position and layout for a custom grid
  const imageWidth = 70 * 0.8; // Image width (80% of 90px)
  const imageHeight = 70 * 0.8; // Image height (80% of 90px)
  const xOffset = 25; // Left margin for the first column
  const yOffset = 15; // Top margin for the first row

  const xSpacing = 55; // Horizontal space between columns
  const ySpacing = imageHeight + 50; // Vertical space between rows (space between products)

  const maxProductsPerPage = 7; // Max products to be displayed per page
  let productCount = 0; // Track the number of products added on the current page

  const lineHeight = 2; // Line height for product details

  // Iterate through the filtered data and add each product to the PDF
  for (let index = 0; index < filteredData.length; index++) {
    const data = filteredData[index];

    // Add a new page if the current page is full (8 products)
    if (productCount >= maxProductsPerPage) {
      doc.addPage(); // Start a new page
      productCount = 0; // Reset the product counter
    }

    // Custom Layout
    let xPos = 0;
    let yPos = 0;

    if (productCount < 4) {
      // First row: 4 products
      xPos = xOffset + (productCount % 4) * (xSpacing + 10); // 4 products in the first row
      yPos = yOffset;
    } else if (productCount >= 4 && productCount < 7) {
      // Second row: 3 products (centered with equal margins on both sides)
      const totalWidthOfProducts = 3 * imageWidth; // Total width of 3 products
      const availableSpace = doc.internal.pageSize.width - 2 * xOffset; // Available space between left and right margins
      const spaceBetweenProducts = (availableSpace - totalWidthOfProducts) / 4; // Distribute the remaining space equally on the left and right of the products

      // Calculate the starting x position to center the products
      xPos =
        xOffset + spaceBetweenProducts + (productCount - 4) * (imageWidth + spaceBetweenProducts);
      yPos = yOffset + ySpacing;
    }

    const detailsXPos = xPos + imageWidth + 10; // Position for the product details to the right of the image

    // doc.setFillColor(211, 211, 211); // Light gray color
    // doc.rect(xPos, yPos, imageWidth, imageHeight, 'F');

    // Add product image
    if (data.CoverImage !== 'No Image') {
      try {
        // Fetch the image as base64
        const img = await fetchImageAsBase64(data.CoverImage);

        // Create an image element
        const imgElement = new Image();
        imgElement.src = img;

        // Wait for the image to load before adding it to the PDF
        await new Promise((resolve, reject) => {
          imgElement.onload = () => {
            const imgAspectRatio = imgElement.width / imgElement.height;

            // Calculate the scaled width and height to maintain the aspect ratio
            let scaledWidth = imageWidth;
            let scaledHeight = imageWidth / imgAspectRatio;

            // If the scaled height exceeds the container height, adjust to fit
            if (scaledHeight > imageHeight) {
              scaledHeight = imageHeight;
              scaledWidth = imageHeight * imgAspectRatio;
            }

            // Ensure the image doesn't exceed the container dimensions
            scaledWidth = Math.min(scaledWidth, imageWidth); // Constrain to container width
            scaledHeight = Math.min(scaledHeight, imageHeight); // Constrain to container height

            // Calculate the X and Y positions to center the image within the container
            const imageXPos = xPos + (imageWidth - scaledWidth) / 2; // Center the image horizontally
            const imageYPos = yPos + (imageHeight - scaledHeight) / 2; // Center the image vertically

            // Add the image to the PDF with the new width, height, and centered position
            doc.addImage(img, 'JPEG', imageXPos, imageYPos, scaledWidth, scaledHeight);

            resolve(); // Resolve the promise once the image is added
          };

          imgElement.onerror = reject; // Reject the promise if there's an error loading the image
        });
      } catch (error) {
        console.log('Error fetching image:', error);
        doc.text('Image Failed', xPos, yPos); // Fallback text if image loading fails
      }
    } else {
      doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    }

    // Add product details to the right of the image
    doc.setFontSize(9); // Font size set to 9 for product details

    // Add a gap of 5 units between the image and the details
    const detailsY = yPos + imageHeight + 5; // Adjusted vertical space to create a 5-unit gap
    const dimensionString = data.Dimension.join(' \n ');
    // Calculate the width of the text box to center the text horizontally
    const textWidth = doc.getTextWidth(`AliasCode: ${data.ProductId}`);
    const centerX = xPos + (imageWidth - textWidth) / 2;

    if (attribute?.includes('ProductId') && label?.[0]?.attributes?.AliasCode && data?.ProductId) {
      doc.text(`${label[0].attributes.AliasCode} :   ${data.ProductId}`, centerX - 12, detailsY);
    }
    if (attribute?.includes('Size')) {
      doc.text(`Size        :`, centerX - 12, detailsY + lineHeight * 2);
    }

    // We will calculate where to position the color info
    const dimensionStartY = detailsY + lineHeight * 2; // Start a bit lower than the label

    // Print the first dimension inline with the "Dimension:" label
    const firstDimension = data.Dimension[0];
    // const firstNetWt = data.NetWt?.[0] > 0 ? `- ${data.NetWt[0]}` : '';
    if (attribute?.includes('Size')) {
      doc.text(`${firstDimension} `, centerX + 4, dimensionStartY); // First dimension inline
    }

    // Print remaining dimensions on subsequent lines, with indentation
    let lineStartY = dimensionStartY + lineHeight * 2; // Space for the next line of dimensions
    lineStartY = attribute?.includes('Size') ? dimensionStartY + lineHeight * 2 : dimensionStartY;

    if (attribute?.includes('Size')) {
      let i = 0;
      data.Dimension.slice(1).forEach((dimension, idx) => {
        if (i < 2) {
          // const netWeight = data.NetWt?.[idx + 1] ? `- ${data.NetWt[idx + 1]}` : '';
          const lineY = lineStartY + idx * (lineHeight * 2);
          doc.text(`${dimension}`, centerX + 4, lineY);
          i++;
        }
      });
    }
    let colorYStart =
      data.Dimension.length >= 3 && attribute?.includes('Size')
        ? lineStartY + lineHeight * 2 + 4
        : data.Dimension.length == 2
        ? lineStartY + lineHeight * 1 + 2
        : lineStartY;

    // Adjust position for the Color field
    if (attribute?.includes('ColorName')) {
      doc.text(
        `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '')
          .slice(0, 3)
          .join('/ ')}`,
        centerX - 12,
        colorYStart
      );
    }
    if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
      let netWtStartY = attribute?.includes('ColorName')
        ? colorYStart + lineHeight * 2
        : colorYStart;

      // Filter valid NetWt values (non-empty, non-zero strings)
      const validNetWtValues = data.NetWt.filter(
        netWt => String(netWt).trim() !== '0' && String(netWt).trim() !== ''
      );

      // Display NetWt values if valid ones exist
      if (validNetWtValues.length > 0) {
        const netWtValues = validNetWtValues.slice(0, 3).join('/ '); // Join valid values
        doc.text(`${label[0].attributes.NetWgt}   :   ${netWtValues}`, centerX - 12, netWtStartY);
      } else {
        // Show label only if no valid NetWt values
        doc.text(`${label[0].attributes.NetWgt}   :`, centerX - 12, netWtStartY);
      }
    }
    // Move to the next product
    productCount++;
  }
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (print) {
    // If the action is 'Print', open PDF in a new window
    window.open(blobUrl, '_blank');
  } else {
    // If the action is 'Download', trigger the PDF download
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = 'Format7_PDF.pdf'; // Set the default filename for the download
    link.click();
  }

  // Revoke blob URL after some time to free up memory
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  return doc;
};
const generatePDF3v8 = async (cata, selectedRowIds, attribute, label) => {
  const doc = new jsPDF('landscape');
  const reversedCata = [
    ...cata.sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    })
  ];
  // Filter the data
  const filteredData = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .map(product => {
      const { CoverImage, ProductId, Length, Width, Height, SizeUnit, SetStatus, SetSizes } =
        product;

      // Start with the basic product data
      const mappedProduct = {
        CoverImage: ip + product.attributes.CoverImage?.data?.attributes?.url || 'No Image',
        ProductId: product.attributes.ProductId || 'No AliasCode',
        SizeUnit: product.attributes.SizeUnit || 'N/A'
      };

      // If SetStatus is 'Set', check for SetSizes
      if (product.attributes.SetStatus === 'Set') {
        if (product.attributes.SetSizes && product.attributes.SetSizes.length > 0) {
          // If SetSizes exists and is not empty, map the SetSizes dimensions and include Description and ColorName
          mappedProduct.Dimension = product.attributes.SetSizes.map(size => {
            return `${size.Description ? size.Description + ' - ' : ''}${size.Length || 0} x ${
              size.Width || 0
            } x ${size.Height || 0} ${size.SizeUnit}`;
          });
          mappedProduct.ColorInfo = product.attributes.SetSizes.map(size =>
            size.ColorName ? size.ColorName : ' '
          );
          mappedProduct.NetWt = product.attributes.SetSizes.map(size =>
            size.NetWt ? size.NetWt : ' '
          );
        } else {
          // If SetSizes is empty, fallback to the main product's dimensions with Description and ColorName
          mappedProduct.Dimension = [
            `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '} `
          ];
          mappedProduct.ColorInfo = product.attributes.ColorName
            ? [product.attributes.ColorName]
            : [' '];
          mappedProduct.NetWt = product.attributes.NetWeight
            ? [product.attributes.NetWeight]
            : [' '];
        }
      } else {
        const { Length, Height, Width, SizeUnit } = product.attributes;
        // If SetStatus is not 'Set', directly use the product's dimensions with Description and ColorName
        mappedProduct.Dimension = [
          `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '}`
        ];
        mappedProduct.ColorInfo = product.attributes.ColorName
          ? [product.attributes.ColorName]
          : [' '];
        mappedProduct.NetWt = product.attributes.NetWeight ? [product.attributes.NetWeight] : [' '];
      }
      return mappedProduct;
    });

  // Set initial position and layout for a custom grid
  const imageWidth = 70 * 0.8; // Image width (80% of 90px)
  const imageHeight = 70 * 0.8; // Image height (80% of 90px)
  const xOffset = 25; // Left margin for the first column
  const yOffset = 15; // Top margin for the first row

  const xSpacing = 55; // Horizontal space between columns
  const ySpacing = imageHeight + 50; // Vertical space between rows (space between products)

  const maxProductsPerPage = 8; // Max products to be displayed per page
  let productCount = 0; // Track the number of products added on the current page

  const lineHeight = 2; // Line height for product details

  // Iterate through the filtered data and add each product to the PDF
  for (let index = 0; index < filteredData.length; index++) {
    const data = filteredData[index];

    // Add a new page if the current page is full (8 products)
    if (productCount >= maxProductsPerPage) {
      doc.addPage(); // Start a new page
      productCount = 0; // Reset the product counter
    }

    // Custom Layout
    // First row: 4 products
    // Second row: 4 products

    let xPos = 0;
    let yPos = 0;

    if (productCount < 4) {
      // First row: 4 products
      xPos = xOffset + (productCount % 4) * (xSpacing + 10); // 4 products in the first row
      yPos = yOffset;
    } else if (productCount >= 4 && productCount < 8) {
      // Second row: 4 products
      xPos = xOffset + ((productCount - 4) % 4) * (xSpacing + 10); // 4 products in the second row
      yPos = yOffset + ySpacing;
    }

    const detailsXPos = xPos + imageWidth + 10; // Position for the product details to the right of the image
    // Y position for the current row
    // Add product image
    // if (data.CoverImage !== 'No Image') {
    //   try {
    //     const img = await fetchImageAsBase64(data.CoverImage);
    //     doc.addImage(img, 'JPEG', xPos, yPos, imageWidth, imageHeight); // Add image
    //   } catch (error) {
    //     console.log('Error fetching image', error);
    //     doc.text('Image Failed', xPos, yPos); // Fallback in case of an error
    //   }
    // } else {
    //   doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    // }
    if (data.CoverImage !== 'No Image') {
      try {
        // Fetch the image as base64
        const img = await fetchImageAsBase64(data.CoverImage);

        // Create an image element
        const imgElement = new Image();
        imgElement.src = img;

        // Wait for the image to load before adding it to the PDF
        await new Promise((resolve, reject) => {
          imgElement.onload = () => {
            const imgAspectRatio = imgElement.width / imgElement.height;

            // Calculate the scaled width and height to maintain the aspect ratio
            let scaledWidth = imageWidth;
            let scaledHeight = imageWidth / imgAspectRatio;

            // If the scaled height exceeds the container height, adjust to fit
            if (scaledHeight > imageHeight) {
              scaledHeight = imageHeight;
              scaledWidth = imageHeight * imgAspectRatio;
            }

            // Ensure the image doesn't exceed the container dimensions
            scaledWidth = Math.min(scaledWidth, imageWidth); // Constrain to container width
            scaledHeight = Math.min(scaledHeight, imageHeight); // Constrain to container height

            // Calculate the X and Y positions to center the image within the container
            const imageXPos = xPos + (imageWidth - scaledWidth) / 2; // Center the image horizontally
            const imageYPos = yPos + (imageHeight - scaledHeight) / 2; // Center the image vertically

            // Add the image to the PDF with the new width, height, and centered position
            doc.addImage(img, 'JPEG', imageXPos, imageYPos, scaledWidth, scaledHeight);

            resolve(); // Resolve the promise once the image is added
          };

          imgElement.onerror = reject; // Reject the promise if there's an error loading the image
        });
      } catch (error) {
        console.log('Error fetching image:', error);
        doc.text('Image Failed', xPos, yPos); // Fallback text if image loading fails
      }
    } else {
      doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    }
    // Add product details to the right of the image
    doc.setFontSize(9); // Font size set to 9 for product details

    // Add a gap of 5 units between the image and the details
    const detailsY = yPos + imageHeight + 5; // Adjusted vertical space to create a 5-unit gap
    const dimensionString = data.Dimension.join(' \n ');
    // Calculate the width of the text box to center the text horizontally
    const textWidth = doc.getTextWidth(`AliasCode: ${data.ProductId}`);
    const centerX = xPos + (imageWidth - textWidth) / 2;

    if (attribute?.includes('ProductId') && label?.[0]?.attributes?.AliasCode && data?.ProductId) {
      doc.text(`${label[0].attributes.AliasCode} :   ${data.ProductId}`, centerX - 12, detailsY);
    }
    if (attribute?.includes('Size')) {
      doc.text(`Size        :`, centerX - 12, detailsY + lineHeight * 2);
    }

    const dimensionStartY = detailsY + lineHeight * 2; // Start a bit lower than the label
    const lineIndentation = -3; // Indentation for each subsequent dimension string

    // Print the first dimension inline with the "Dimension:" label
    const firstDimension = data.Dimension[0];
    // const firstNetWt = data.NetWt?.[0] > 0 ? `- ${data.NetWt[0]}` : '';
    if (attribute?.includes('Size')) {
      doc.text(`${firstDimension} `, centerX + 4, dimensionStartY); // First dimension inline
    }

    // Print remaining dimensions on subsequent lines, with indentation
    let lineStartY = dimensionStartY + lineHeight * 2; // Space for the next line of dimensions
    lineStartY = attribute?.includes('Size') ? dimensionStartY + lineHeight * 2 : dimensionStartY;

    if (attribute?.includes('Size')) {
      let i = 0;
      data.Dimension.slice(1).forEach((dimension, idx) => {
        if (i < 2) {
          // const netWeight = data.NetWt?.[idx + 1] ? `- ${data.NetWt[idx + 1]}` : '';
          const lineY = lineStartY + idx * (lineHeight * 2);
          doc.text(`${dimension}`, centerX + 4, lineY);
          i++;
        }
      });
    }

    let colorYStart =
      data.Dimension.length >= 3 && attribute?.includes('Size')
        ? lineStartY + lineHeight * 2 + 4
        : data.Dimension.length == 2
        ? lineStartY + lineHeight * 1 + 2
        : lineStartY;

    // Adjust position for the Color field
    if (attribute?.includes('ColorName')) {
      doc.text(
        `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '')
          .slice(0, 3)
          .join('/ ')}`,
        centerX - 12,
        colorYStart
      );
    }
    if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
      let netWtStartY = attribute?.includes('ColorName')
        ? colorYStart + lineHeight * 2
        : colorYStart;

      // Filter valid NetWt values (non-empty, non-zero strings)
      const validNetWtValues = data.NetWt.filter(
        netWt => String(netWt).trim() !== '0' && String(netWt).trim() !== ''
      );

      // Display NetWt values if valid ones exist
      if (validNetWtValues.length > 0) {
        const netWtValues = validNetWtValues.slice(0, 3).join('/ '); // Join valid values
        doc.text(`${label[0].attributes.NetWgt}   :   ${netWtValues}`, centerX - 12, netWtStartY);
      } else {
        // Show label only if no valid NetWt values
        doc.text(`${label[0].attributes.NetWgt}   :`, centerX - 12, netWtStartY);
      }
    }

    // Move to the next product
    productCount++;
  }
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (print) {
    // If the action is 'Print', open PDF in a new window
    window.open(blobUrl, '_blank');
  } else {
    // If the action is 'Download', trigger the PDF download
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = 'Format8_PDF.pdf'; // Set the default filename for the download
    link.click();
  }

  // Revoke blob URL after some time to free up memory
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  return doc;
};

const generatePDF3v9 = async (cata, selectedRowIds, attribute, label, setIsLoading3) => {
  const doc = new jsPDF('landscape');
  const reversedCata = [
    ...cata.sort((a, b) => {
      // Sort by id in ascending order
      return b.id - a.id; // Change to b.id - a.id for descending order
    })
  ];
  // Filter and map the products based on selectedRowIds
  const filteredData = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .map(product => {
      const { CoverImage, ProductId, Length, Width, Height, SizeUnit, SetStatus, SetSizes } =
        product;

      const mappedProduct = {
        CoverImage: ip + product.attributes.CoverImage?.data?.attributes?.url || 'No Image',
        ProductId: product.attributes.ProductId || 'No AliasCode',
        SizeUnit: product.attributes.SizeUnit || 'N/A',
        NetWeight: product.attributes.NetWeight || 'NetWt'
      };

      // Handle SetStatus and dimensions
      if (product.attributes.SetStatus === 'Set') {
        if (product.attributes.SetSizes && product.attributes.SetSizes.length > 0) {
          mappedProduct.Dimension = product.attributes.SetSizes.map(size => {
            return `${size.Description ? size.Description + ' - ' : ''}${size.Length || 0} x ${
              size.Width || 0
            } x ${size.Height || 0} ${size.SizeUnit}`;
          });
          mappedProduct.ColorInfo = product.attributes.SetSizes.map(size =>
            size.ColorName ? size.ColorName : ' '
          );
          mappedProduct.NetWt = product.attributes.SetSizes.map(size =>
            size.NetWt ? size.NetWt : ' '
          );
        } else {
          mappedProduct.Dimension = [
            `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '} `
          ];
          mappedProduct.ColorInfo = product.attributes.ColorName
            ? [product.attributes.ColorName]
            : [' '];

          mappedProduct.NetWt = product.attributes.NetWeight
            ? [product.attributes.NetWeight]
            : [' '];
        }
      } else {
        mappedProduct.Dimension = [
          `${Length || 0} x ${Width || 0} x ${Height || 0} ${SizeUnit ? SizeUnit : ' '}`
        ];
        mappedProduct.ColorInfo = product.attributes.ColorName
          ? [product.attributes.ColorName]
          : [' '];

        mappedProduct.NetWt = product.attributes.NetWeight ? [product.attributes.NetWeight] : [' '];
      }

      return mappedProduct;
    });

  const imageWidth = 60 * 0.8; // Image width adjusted to 80% of the original size
  const imageHeight = 50 * 0.8; // Image height adjusted to 80% of the original size
  const xOffset = 30; // Left margin for the first column
  const yOffset = 5; // Top margin for the first row
  const xSpacing = 90; // Horizontal space between columns
  const ySpacing = imageHeight + 28; // Vertical space between rows
  const maxProductsPerPage = 9; // 3x3 grid
  let productCount = 0; // Track the number of products on the current page

  const lineHeight = 2; // Line height for text

  // Iterate through the filtered data and add each product to the PDF
  for (let index = 0; index < filteredData.length; index++) {
    const data = filteredData[index];

    // Add a new page if the current page is full (9 products)
    if (productCount >= maxProductsPerPage) {
      doc.addPage();
      productCount = 0;
    }

    // Calculate the row and column for the current product in the 3x3 grid
    const row = Math.floor(productCount / 3); // 3 columns per row
    const col = productCount % 3; // 3 rows per page

    const xPos = xOffset + col * xSpacing; // X position for the current column
    const yPos = yOffset + row * ySpacing; // Y position for the current row

    // Add product image
    if (data.CoverImage !== 'No Image') {
      try {
        // Fetch the image as base64
        const img = await fetchImageAsBase64(data.CoverImage);

        // Create an image element
        const imgElement = new Image();
        imgElement.src = img;

        // Wait for the image to load before adding it to the PDF
        await new Promise((resolve, reject) => {
          imgElement.onload = () => {
            const imgAspectRatio = imgElement.width / imgElement.height;

            // Calculate the scaled width and height to maintain the aspect ratio
            let scaledWidth = imageWidth;
            let scaledHeight = imageWidth / imgAspectRatio;

            // If the scaled height exceeds the container height, adjust to fit
            if (scaledHeight > imageHeight) {
              scaledHeight = imageHeight;
              scaledWidth = imageHeight * imgAspectRatio;
            }

            // Ensure the image doesn't exceed the container dimensions
            scaledWidth = Math.min(scaledWidth, imageWidth); // Constrain to container width
            scaledHeight = Math.min(scaledHeight, imageHeight); // Constrain to container height

            // Calculate the X and Y positions to center the image within the container
            const imageXPos = xPos + (imageWidth - scaledWidth) / 2; // Center the image horizontally
            const imageYPos = yPos + (imageHeight - scaledHeight) / 2; // Center the image vertically

            // Add the image to the PDF with the new width, height, and centered position
            doc.addImage(img, 'JPEG', imageXPos, imageYPos, scaledWidth, scaledHeight);

            resolve(); // Resolve the promise once the image is added
          };

          imgElement.onerror = reject; // Reject the promise if there's an error loading the image
        });
      } catch (error) {
        console.log('Error fetching image:', error);
        doc.text('Image Failed', xPos, yPos); // Fallback text if image loading fails
      }
    } else {
      doc.text('No Image', xPos, yPos); // Fallback text if no image is available
    }

    // Add product details to the right of the image
    doc.setFontSize(9); // Font size for product details
    const detailsY = yPos + imageHeight + 5; // Adjusted vertical space for details

    // Format dimension string based on whether it's a single set or multiple sets
    const dimensionString = data.Dimension.join(' \n '); // Join dimensions into one string if there are multiple sets

    // Calculate the width of the text box for centering the text horizontally
    const textWidth = doc.getTextWidth(`AliasCode: ${data.ProductId}`);
    const centerX = xPos + (imageWidth - textWidth) / 2;

    if (attribute?.includes('ProductId') && label?.[0]?.attributes?.AliasCode && data?.ProductId) {
      doc.text(`${label[0].attributes.AliasCode} :   ${data.ProductId}`, centerX - 12, detailsY);
    }
    if (attribute?.includes('Size')) {
      doc.text(`Size        :`, centerX - 12, detailsY + lineHeight * 2);
    }

    const dimensionStartY = detailsY + lineHeight * 2;

    // Print the first dimension inline with the "Dimension:" label
    const firstDimension = data.Dimension[0];
    // const firstNetWt = data.NetWt?.[0] > 0 ? `- ${data.NetWt[0]}` : '';
    if (attribute?.includes('Size')) {
      doc.text(`${firstDimension} `, centerX + 4, dimensionStartY); // First dimension inline
    }

    // Print remaining dimensions on subsequent lines, with indentation
    let lineStartY = dimensionStartY + lineHeight * 2; // Space for the next line of dimensions
    lineStartY = attribute?.includes('Size') ? dimensionStartY + lineHeight * 2 : dimensionStartY;

    if (attribute?.includes('Size')) {
      let i = 0;
      data.Dimension.slice(1).forEach((dimension, idx) => {
        if (i < 2) {
          // const netWeight = data.NetWt?.[idx + 1] ? `- ${data.NetWt[idx + 1]}` : '';
          const lineY = lineStartY + idx * (lineHeight * 2);
          doc.text(`${dimension}`, centerX + 4, lineY);
          i++;
        }
      });
    }

    let colorYStart =
      data.Dimension.length >= 3 && attribute?.includes('Size')
        ? lineStartY + lineHeight * 2 + 4
        : data.Dimension.length == 2
        ? lineStartY + lineHeight * 1 + 2
        : lineStartY;

    if (attribute?.includes('ColorName')) {
      doc.text(
        `${label[0].attributes.color}     :   ${data.ColorInfo.filter(color => color.trim() !== '')
          .slice(0, 3)
          .join('/ ')}`,
        centerX - 12,
        colorYStart
      );
    }

    if (data.NetWt && data.NetWt.length > 0 && attribute?.includes('NetWeight')) {
      // Calculate position for NetWt dynamically based on color field
      let netWtStartY = attribute?.includes('ColorName')
        ? colorYStart + lineHeight * 2
        : colorYStart;

      // Filter valid NetWt values (non-empty, non-zero strings)
      const validNetWtValues = data.NetWt.filter(
        netWt => String(netWt).trim() !== '0' && String(netWt).trim() !== ''
      );

      // Display NetWt values if valid ones exist
      if (validNetWtValues.length > 0) {
        const netWtValues = validNetWtValues.slice(0, 3).join('/ '); // Join valid values
        doc.text(`${label[0].attributes.NetWgt}   :   ${netWtValues}`, centerX - 12, netWtStartY);
      } else {
        // Show label only if no valid NetWt values
        doc.text(`${label[0].attributes.NetWgt}   :`, centerX - 12, netWtStartY);
      }
    }

    productCount++; // Move to the next product
  }
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  if (print) {
    // If the action is 'Print', open PDF in a new window
    window.open(blobUrl, '_blank');
  } else {
    // If the action is 'Download', trigger the PDF download
    doc.save('Format9_PDF.pdf');
  }

  // Revoke the Blob URL after 1 minute to free up memory
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);

  setIsLoading3(false);
  return doc;
};

const generatePDF3v16 = async (
  cata,
  selectedRowIds,
  attribute,
  label,
  setIsLoading3,
  maxProductsPerPage = 16,
  unit = 'cm',
  currency = 'USD',
  selectedRate
) => {
  const doc = new jsPDF('landscape');
  const reversedCata = [...cata.sort((a, b) => b.id - a.id)];

  const filteredData = reversedCata
    .filter(product => selectedRowIds.includes(product.id))
    .map(product => {
      const { Length, Width, Height, SizeUnit } = product;
      let price = parseFloat(product.attributes.SellingPrice) || 0;

      // Convert INR → selected currency
      if (currency !== 'INR' && selectedRate) {
        price = price / selectedRate;
      }

      price = Number(price.toFixed(2));

      const mappedProduct = {
        CoverImage: product.attributes.CoverImage?.data?.attributes?.url
          ? ip + product.attributes.CoverImage?.data?.attributes?.url
          : 'No Image',
        ProductId: product.attributes.ProductId || 'No AliasCode',
        SizeUnit: product.attributes.SizeUnit || 'N/A',

        // ✅ ADDED — pricing values (simple)
        SellingPrice: price || '',
        SellingPriceCurrency: currency || ''
      };

      const selectedUnit = unit.toLowerCase();

      if (product.attributes.SetStatus === 'Set') {
        if (product.attributes.SetSizes?.length > 0) {
          mappedProduct.Dimension = product.attributes.SetSizes.map(size => {
            const originalUnit = size.SizeUnit?.toLowerCase().includes('inch') ? 'inch' : 'cm';

            const l = convertDimension(size.Length || 0, originalUnit, selectedUnit);
            const w = convertDimension(size.Width || 0, originalUnit, selectedUnit);
            const h = convertDimension(size.Height || 0, originalUnit, selectedUnit);

            return `${
              size.Description ? size.Description + ' - ' : ''
            }${l} x ${w} x ${h} ${selectedUnit}`;
          });

          mappedProduct.ColorInfo = product.attributes.SetSizes.map(size => size.ColorName || ' ');

          mappedProduct.NetWt = product.attributes.SetSizes.map(size => size.NetWt || ' ');
        } else {
          const originalUnit = product.attributes.SizeUnit?.toLowerCase().includes('inch')
            ? 'inch'
            : 'cm';

          const l = convertDimension(product.attributes.Length || 0, originalUnit, selectedUnit);
          const w = convertDimension(product.attributes.Width || 0, originalUnit, selectedUnit);
          const h = convertDimension(product.attributes.Height || 0, originalUnit, selectedUnit);

          mappedProduct.Dimension = [`${l} x ${w} x ${h} ${selectedUnit}`];
          mappedProduct.ColorInfo = [product.attributes.ColorName || ' '];
          mappedProduct.NetWt = [product.attributes.NetWeight || ' '];
        }
      } else {
        const originalUnit = product.attributes.SizeUnit?.toLowerCase().includes('inch')
          ? 'inch'
          : 'cm';

        const l = convertDimension(product.attributes.Length || 0, originalUnit, selectedUnit);
        const w = convertDimension(product.attributes.Width || 0, originalUnit, selectedUnit);
        const h = convertDimension(product.attributes.Height || 0, originalUnit, selectedUnit);

        mappedProduct.Dimension = [`${l} x ${w} x ${h} ${selectedUnit}`];
        mappedProduct.ColorInfo = [product.attributes.ColorName || ' '];
        mappedProduct.NetWt = [product.attributes.NetWeight || ' '];
      }

      return mappedProduct;
    });

  const cols = Math.ceil(Math.sqrt(maxProductsPerPage));
  const rows = Math.ceil(maxProductsPerPage / cols);

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const xOffset = 15;
  const yOffset = 10;

  const xSpacing = (pageWidth - 2 * xOffset) / cols;
  const ySpacing = (pageHeight - 2 * yOffset) / rows;

  const imageWidth = xSpacing * 0.8;
  const imageHeight = ySpacing * 0.55;

  let productCount = 0;
  const lineHeight = 2;

  for (let index = 0; index < filteredData.length; index++) {
    const data = filteredData[index];

    if (productCount >= maxProductsPerPage) {
      doc.addPage();
      productCount = 0;
    }

    const row = Math.floor(productCount / cols);
    const col = productCount % cols;

    const xPos = xOffset + col * xSpacing;
    const yPos = yOffset + row * ySpacing;

    if (data.CoverImage !== 'No Image') {
      try {
        const img = await fetchImageAsBase64(data.CoverImage);
        doc.addImage(img, 'JPEG', xPos, yPos, imageWidth, imageHeight);
      } catch {
        doc.text('Image Failed', xPos, yPos);
      }
    }

    doc.setFontSize(7);
    const detailsY = yPos + imageHeight + 5;
    const centerX = xPos + imageWidth / 2;

    if (attribute?.includes('ProductId')) {
      doc.text(
        `${label?.[0]?.attributes?.AliasCode || 'Code'} : ${data.ProductId}`,
        centerX - 12,
        detailsY
      );
    }

    let currentY = detailsY + lineHeight * 2;

    if (attribute?.includes('Size')) {
      const sizeLabel = label?.[0]?.attributes?.Size || 'Size';

      // Print up to 3 dimensions, separated by " / " if multiple
      const dimensionText = data.Dimension.slice(0, 3).join(' / ');

      // Print label + values on the same line, aligned with other fields
      doc.text(`${sizeLabel} : ${dimensionText}`, centerX - 12, currentY);

      // Increment Y for next field
      currentY += lineHeight * 2;
    }

    // ---------- SELLING PRICE ----------
    if (attribute?.includes('SellingPrice')) {
      const price = data?.SellingPrice ?? 0;

      const displayPrice = `${price} ${currency}`;

      doc.text(
        `${label?.[0]?.attributes?.SellingPrice || 'Price'} : ${displayPrice}`,
        centerX - 12,
        currentY
      );

      currentY += lineHeight * 2;
    }

    // ---------- COLOR ----------
    if (attribute?.includes('ColorName')) {
      const colors = data.ColorInfo.filter(c => c.trim())
        .slice(0, 3)
        .join(' / ');

      doc.text(`${label?.[0]?.attributes?.color || 'Color'} : ${colors}`, centerX - 12, currentY);

      currentY += lineHeight * 2; // ✅ MOVE DOWN
    }

    // ---------- NET WEIGHT ----------
    if (attribute?.includes('NetWeight')) {
      const netWt = data.NetWt.filter(n => n && n !== '0')
        .slice(0, 3)
        .join(' / ');

      doc.text(`${label?.[0]?.attributes?.NetWgt || 'Net Wt'} : ${netWt}`, centerX - 12, currentY);

      currentY += lineHeight * 2; // ✅ MOVE DOWN
    }

    productCount++;
  }

  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  print ? window.open(blobUrl, '_blank') : doc.save('Format3v16_PDF.pdf');
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  setIsLoading3(false);

  return doc;
};

// Helper function to fetch image as a base64 string
const fetchImageAsBase64 = async url => {
  if (!url.endsWith('undefined')) {
    const response = await fetch(url);
    const blob = await response.blob();
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }
};
const handleDownloadPDF3 = async (
  attribute,
  setIsLoading3,
  setIsLoading2,
  inputNumber,
  selectedRowIds,
  cata,
  label,
  selectedUnit,
  selectedCurrency,
  selectedRate
) => {
  const number = parseInt(inputNumber, 10);
  // Validate the number and selected rows
  // console.log('Attributes ', attribute);
  if (print) {
    setIsLoading3(true);
  } else {
    setIsLoading2(true);
  }

  if (isNaN(number) || number < 1 || number > 30) {
    toaster.push(
      <Message showIcon type="warning">
        Please enter a valid number between 1 and 30
      </Message>,
      { placement: 'topCenter' }
    );
    return;
  }

  if (selectedRowIds.length === 0) {
    console.error('No rows selected!');
    return;
  }
  try {
    // ✅ normalize number (fallback between 1–30)
    const perPage = number && number >= 1 && number <= 30 ? number : 16;

    // ✅ always use ONE function
    const doc = await generatePDF3v16(
      cata,
      selectedRowIds,
      attribute,
      label,
      setIsLoading3,
      perPage,
      selectedUnit,
      selectedCurrency,
      selectedRate
    );

    if (print) {
      doc.save('PDF.pdf');
      setIsLoading3(false);
    } else {
      setIsLoading2(false);
    }
  } catch (error) {
    console.error('Error generating PDF:', error);
    setIsLoading3(false);
    setIsLoading2(false);
  }

  // try {
  //   let doc;
  //   switch (number) {
  //     case 1:
  //       doc = await generatePDF3v1(cata, selectedRowIds, attribute, label);
  //       break;
  //     case 2:
  //       doc = await generatePDF3v2(cata, selectedRowIds, attribute, label);
  //       break;
  //     case 3:
  //       doc = await generatePDF3v3(cata, selectedRowIds, attribute, label, setIsLoading3);
  //       break;
  //     case 4:
  //       doc = await generatePDF3v4(cata, selectedRowIds, attribute, label, setIsLoading3);
  //       break;
  //     case 5:
  //       doc = await generatePDF3v5(cata, selectedRowIds, attribute, label);
  //       break;
  //     case 6:
  //       doc = await generatePDF3v6(cata, selectedRowIds, attribute, label);
  //       break;
  //     case 7:
  //       doc = await generatePDF3v7(cata, selectedRowIds, attribute, label);
  //       break;
  //     case 8:
  //       doc = await generatePDF3v8(cata, selectedRowIds, attribute, label);
  //       break;
  //     case 9:
  //       doc = await generatePDF3v9(cata, selectedRowIds, attribute, label, setIsLoading3);
  //       break;
  //     case 16:
  //       doc = await generatePDF3v16(cata, selectedRowIds, attribute, label, setIsLoading3, 16);
  //       break;
  //     case 30:
  //       doc = await generatePDF3v16(
  //         cata,
  //         selectedRowIds,
  //         attribute,
  //         label,
  //         setIsLoading3,
  //         30 // ✅ force 30 per page
  //       );
  //       break;

  //     default:
  //       // ✅ dynamic fallback (1–30)
  //       doc = await generatePDF3v16(
  //         cata,
  //         selectedRowIds,
  //         attribute,
  //         label,
  //         setIsLoading3,
  //         number // user-defined per-page count
  //       );
  //       break;
  //   }
  //   // console.log("Value" , printOrNot)
  //   if (print) {
  //     // doc.output('dataurlnewwindow');
  //     setIsLoading3(false);
  //   } else {
  //     // doc.save('Format3_PDF.pdf');
  //     setIsLoading2(false);
  //   }
  // } catch (error) {
  //   console.error('Error generating PDF:', error);
  // }
};
export { handleDownloadPDF1, handleDownloadPDF2, handleDownloadPDF3 };
